import * as tracking from '../../../tracking';

import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {cloneDeep} from 'lodash';
import CreatePhaseMutation from '../../../mutations/create_phase_mutation';
import DeleteTaskMutation from '../../../mutations/delete_task_mutation';
import {DragDropContext} from '@forecasthq/react-virtualized-dnd';
import EmptyState from '../../../forecast-app/shared/components/empty-states/empty_state';
import FilterPerson from '../../../components/filter_person';
import Moment from 'moment';
import PhasesPeriodHeader from '../../../components/new-ui/scoping/phases_period_header';
import PhasesPhase from '../../../components/new-ui/scoping/phases_phase';
import PhasesPhaseHeader from '../../../components/new-ui/scoping/phases_phase_header';
import ProjectTotalHeader from '../../../components/new-ui/scoping/project_total_header';
import ReorderTaskMutation from '../../../mutations/reorder_task_mutation.modern';
import UpdateTaskMutation from '../../../mutations/update_task_mutation.modern';
import Util from '../../../forecast-app/shared/util/util';
import ProjectUtil from '../../../forecast-app/shared/util/project_util';
import VisibilitySensor from 'react-visibility-sensor';
import {createToast} from '../../../forecast-app/shared/components/toasts/another-toast/toaster';
import {MODAL_TYPE, showModal} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import InsightsEmptyState from '../../../forecast-app/shared/components/empty-states/insights_empty_state';
import HeaderBar, {buildThirdLevelNavHeader} from '../../../forecast-app/shared/components/headers/header-bar/header_bar';
import constants, {BUDGET_TYPE, BUTTON_COLOR, BUTTON_STYLE, BUTTON_VARIANT, ELEMENT_TYPE, EMPTY_STATE, FILTER_SECTION, FILTER_TYPE, MAX_BULK_SELECTION, PERIOD_BUDGET_TYPE, SOCKET_ACTION, SOCKET_EVENT_TYPE, WorkflowCategories} from '../../../constants';
import {FILTER_SECTIONS} from '../../../forecast-app/shared/components/filters/FilterWrapper';
import {getFiltersAlphabetically} from '../../../forecast-app/shared/components/filters/filter_util';
import {getFilterFunctions} from '../../../forecast-app/shared/components/filters/filter_logic';
import {PhasesBaselineHeader} from '../../../components/new-ui/scoping/PhasesBaselineHeader';
import {timeRegIsInConflict} from '../../../components/new-ui/retainer_period/RetainerPeriodUtil';
import {dispatch, EVENT_ID, subscribe, unsubscribe} from '../../event_manager';
import {hasFeatureFlag} from '../../../forecast-app/shared/util/FeatureUtil';
import {TopHeaderBar, TopHeaderBarWrapper} from '../../../forecast-app/shared/components/headers/top-header-bar/TopHeaderBar';
import {FixedPriceValueBasedTaskDistributor} from '../../../forecast-app/shared/util/FixedPriceUtil';
import TaskFormatter from '../../../forecast-app/shared/util/export-formatters/TaskFormatter';
import {hasSomePermission, hasPermission, isClientUser, personIsClientUser} from '../../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../Permissions';
import { BulkSelectPopup } from 'web-components';
import { ArrowRightOutline, BinOutline, MoreActionsOutline } from '../../../images/svg-collection';
import { getComplexBulkOptions } from '../../../forecast-app/shared/util/BulkUtil';

const tabs = [
	{translationId: 'common.all_milestones', value: 'all'},
	{translationId: 'common.done_milestones', value: 'done'},
	{translationId: 'common.active_milestones', value: 'active'},
];

class ProjectPhases extends Component {
	constructor(props) {
		super(props);
		//this.drawFrame = this.drawFrame.bind(this);
		this.state = props.viewer.project ? this.getFreshStateObject(props) : {};
		this.handleShortcutProjectPhases = this.handleShortcutProjectPhases.bind(this);
		this.scrollToNewMilestone = this.scrollToNewMilestone.bind(this);
		this.onWindowResize = this.onWindowResize.bind(this);
		this.registerRowSelection = this.registerRowSelection.bind(this);
		this.handleDeselectMultipleTasks = this.handleDeselectMultipleTasks.bind(this);
		this.handleSelectMultipleTasks = this.handleSelectMultipleTasks.bind(this);
		this.constructHeaderBar = this.constructHeaderBar.bind(this);
		this.logFirstMutation = this.logFirstMutation.bind(this);
		this.state = {...this.state, showFilter: true};

		this.refetch = this.refetch.bind(this);
		
		this.fixedPriceUtil = this._getFixedPriceUtil(props);
		if (this.fixedPriceUtil) {
			this.state = {...this.state, fixedPriceRefreshToggle: false};
		}
	}

	UNSAFE_componentWillMount() {
		const path = this.props.history.location.pathname;
		if (!Util.AuthorizeViewerAccess('project-phases')) {
			if (Util.pathIncludesTask(path)) {
				const cardPath = path.substring(Util.indexOfTask(path), path.length);
				this.props.history.push('/project/P-' + this.props.viewer.project.companyProjectId + '/workflow/' + cardPath);
			} else {
				// if user doesnt have access rights to view this page redirect to no access page
				this.props.history.push('/not-authorized');
				Util.localStorageSetItem('project-section-last-viewed', 'workflow');
			}
		}
	}

	componentDidMount() {
		this.updateTaskCellMaxWidth();
		document.addEventListener('keydown', this.handleShortcutProjectPhases);
		window.addEventListener('resize', this.onWindowResize);
		tracking.trackPageLoad('Scoping view', {tab_selected: this.state.selectedTab.value});
		subscribe(EVENT_ID.MUTATION_SENT, this.logFirstMutation);

		const cols = this.state.availableColumns.slice();
		const width = this.getColWidths();
		cols.map(col => (col.width = width));
		this.setState({availableColumns: cols});
		this.updateStorageCollapse();
		if (this.props.viewer.project.phases.edges.length === 0) {
			this.setState({projectTotalExpanded: false});
		}
		if (this.section_body && this.dnd_context) {
			const screenHeight = window.innerHeight;
			// 10px margin below header
			const headerBarHeight = this.header_bar.getBoundingClientRect().bottom + (this.props.buyNowTime ? 40 : 0);
			const contextHeight = screenHeight - headerBarHeight;
			this.setState({contextHeight: contextHeight});
		}

		this.setState({containerWidth: this.getContainerWidth()});
		//const collapsed = this.shouldMilestoneStartClosed(map);
		//this.setState({collapseAll: !collapsed});

		const phaseSectionId = window.location.hash.substr(1);
		const phaseElement = document.getElementById('phase-' + phaseSectionId);

		if (phaseElement && this.refs.scrollbar) {
			// To position screen slightly above the milestone
			const offset = 200;
			this.refs.scrollbar.scrollTop(phaseElement.getBoundingClientRect().top - offset);
		}

		const name = this.props.viewer.project.name !== null && this.props.viewer.project.name !== '' ? this.props.viewer.project.name : 'P-' + this.props.viewer.project.companyProjectId;
		document.title = 'Scoping - ' + name + ' - Forecast';

		//const columns = this.state.display.filter(column => column.checked).map(column => column.name);
		tracking.trackPage('project-scoping');
		if (this.state.availableColumns) {
			const eyeOptions = [];
			this.state.availableColumns.filter(elem => elem.name !== 'chip-right' && elem.name !== 'selector' && elem.name !== 'task-name' && elem.checked).map(elem => eyeOptions.push({name: elem.name, checked: true}));
			tracking.trackEyeSelector(eyeOptions);
		}
		/*canScrollPhasesInterval = setInterval(() => {
			canScrollPhases = true;
		}, 20);*/
		if (this.props.viewer.project.tasks.edges.length !== 0 || this.props.viewer.project.phases.edges.length !== 0) {
			//this.calculateTablesSize();
		}

		const projectIds = parseInt(atob(this.props.viewer.project.id).replace('ProjectType:', ''));
		const actualPersonIdInt = parseInt(atob(this.props.viewer.actualPersonId).replace('Person:', ''));
		const socketEvents = [
			{
				type: SOCKET_EVENT_TYPE.PROJECT,
				action: SOCKET_ACTION.DELETE,
				projectIds: projectIds,
			},
			{
				type: SOCKET_EVENT_TYPE.PROJECT,
				action: SOCKET_ACTION.UPDATE,
				projectIds: projectIds,
			},
			{
				type: SOCKET_EVENT_TYPE.TIME_LOCK,
				action: SOCKET_ACTION.UPDATE,
				personIds: actualPersonIdInt,
			},
			{
				type: SOCKET_EVENT_TYPE.TASK,
				action: SOCKET_ACTION.UPDATE,
				projectIds: projectIds,
			},
			{
				type: SOCKET_EVENT_TYPE.TASK,
				action: SOCKET_ACTION.CREATE,
				projectIds: projectIds,
			},
			{
				type: SOCKET_EVENT_TYPE.TASK,
				action: SOCKET_ACTION.DELETE,
				projectIds: projectIds,
			},
			{
				type: SOCKET_EVENT_TYPE.PHASE,
				action: SOCKET_ACTION.UPDATE,
				projectIds: projectIds,
			},
			{
				type: SOCKET_EVENT_TYPE.PHASE,
				action: SOCKET_ACTION.CREATE,
				projectIds: projectIds,
			},
			{
				type: SOCKET_EVENT_TYPE.PHASE,
				action: SOCKET_ACTION.DELETE,
				projectIds: projectIds,
			},
		];
		if (!hasPermission(PERMISSION_TYPE.PROJECTS_READ_ALL)) {
			socketEvents.push({
				type: SOCKET_EVENT_TYPE.PROJECT_PERSON,
				action: SOCKET_ACTION.DELETE,
				projectIds: projectIds,
				personIds: this.props.viewer.backendId,
			});
		}

		this.props.setSocketConfig(socketEvents);
		this.refetch();

		this.mutationtimeMonitoring = performance.now();

		dispatch(EVENT_ID.PAGE_LOADED, 'project_phases');
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.props.viewer.project.id !== nextProps.viewer.project.id) {
			this.setState(this.getFreshStateObject(nextProps));
		}
	}

	componentDidUpdate(prevProps, prevState) {
		//Util.logUpdateReason(this.props, this.state, prevProps, prevState);

		const width = this.getTaskCellMaxWidth();
		if (this.props.containerWidth !== prevProps.containerWidth || width !== this.state.taskCellMaxWidth) {
			this.updateTaskCellMaxWidth();
		}

		// Reset selectedTasks if a task is deleted to exclude the deleted tasks.
		if (this.state.selectedTasks.length > 0 && this.props.viewer.project.tasks.edges.length < prevProps.viewer.project.tasks.edges.length) {
			const prevSelectedTaskIds = this.state.selectedTasks.map(task => task.node.id);
			const newSelectedTasks = this.props.viewer.project.tasks.edges.filter(task => prevSelectedTaskIds.includes(task.node.id));
			this.setState({selectedTasks: newSelectedTasks});
		}

		this.setShouldCollapseAll();
		//let displayChanged = false;
		const containerWidth = this.getContainerWidth();
		if (containerWidth !== this.state.containerWidth) {
			this.setState({containerWidth: this.getContainerWidth()});
		}
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleShortcutProjectPhases);
		window.removeEventListener('resize', this.onWindowResize);
		unsubscribe(EVENT_ID.MUTATION_SENT, this.logFirstMutation);
		cancelAnimationFrame(this.requestedFrame);
		//clearInterval(canScrollPhasesInterval);
	}

	_getFixedPriceUtil(props) {
		if (props.viewer.project && props.viewer.project.budgetType === 'FIXED_PRICE_V2') {
			const rateCard = props.viewer.project.rateCard;
			const fixedPrice = props.viewer.project.budgetWork;
			const taskList = props.viewer.project.tasks.edges.map(edge => edge.node);
			const statusColumns = props.viewer.project.statusColumnsV2.edges.map(edge => edge.node);
			return new FixedPriceValueBasedTaskDistributor(taskList, fixedPrice, rateCard, statusColumns, () => {
				this.setState({
					fixedPriceRefreshToggle: !this.state.fixedPriceRefreshToggle,
				});
			});
		}
		return null;
	}

	refetch() {
		if (this.props.refetch) {
			this.props.refetch(
				{
					fetchLazyData: true,
				},
				null,
				() => this.setState({lazyDataFetched: true})
			);
		} else {
			this.props.retry();
		}
	}

	logFirstMutation(mutationId) {
		const mutationTime = Math.round(performance.now() - this.mutationtimeMonitoring);
		if (!this.mutationLogged && mutationId !== 'updateViewerMutation') {
			tracking.trackEvent('Scoping First Mutation', {time: mutationTime});
			this.mutationLogged = true;
		}
	}

	getContextHeight() {
		const screenHeight = window.innerHeight;
		// 10px margin below header
		const headerBarHeight = this.header_bar.getBoundingClientRect().bottom + 16 + (this.props.buyNowTime ? 40 : 0);
		return screenHeight - headerBarHeight;
	}

	isEmpty(obj) {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) return false;
		}
		return true;
	}

	updateStorageCollapse() {
		const storedMap = JSON.parse(localStorage.getItem(this.props.viewer.project.id + '-map') || null);
		const map = new Map(storedMap && !this.isEmpty(storedMap) ? storedMap : null);
		let newMap = new Map();
		const allPhases = this.phases;

		allPhases.forEach(phase => {
			const id = phase.id;
			if (map.has(id)) {
				newMap.set(id, map.get(id));
			} else {
				newMap.set(id, !this.shouldPhaseStartClosed(phase));
			}
		});
		Util.localStorageSetItem(this.props.viewer.project.id + '-map', JSON.stringify(newMap));
		this.setState({
			phasesMap: newMap,
		});
	}

	updateTaskCellMaxWidth() {
		const taskCellMaxWidth = this.getTaskCellMaxWidth();
		const minWidth = this.state.availableColumns.reduce((acc, elem) => acc + (elem.checked ? (elem.name === 'task-name' ? taskCellMaxWidth : elem.name === 'task-id' || elem.name === 'selector' ? 0 : elem.minWidth) : 0), 0);
		this.setState({taskCellMaxWidth: taskCellMaxWidth, tableMinWidth: minWidth});
	}

	onWindowResize() {
		if (this.section_body && this.dnd_context) {
			this.setState(
				{
					containerWidth: this.getContainerWidth(),
					contextHeight: this.getContextHeight(),
				},
				() => this.updateTaskCellMaxWidth()
			);
		} else this.setState({containerWidth: this.getContainerWidth()}, () => this.updateTaskCellMaxWidth());
	}

	getFreshStateObject(props) {
		const {formatMessage} = props.intl;
		//const localStorageColumns = JSON.parse(localStorage.getItem('columns-project-phases')) || [];

		let phases = cloneDeep(this.props.viewer.project.phases.edges).map(phase => phase.node);
		phases = Util.sortMilestones(phases, false);

		// create the map that handles the milestone order
		const phasesOrderMap = new Map();
		phases.forEach((phase, index) => {
			phasesOrderMap.set(phase.id, index);
		});

		let burgerMenuOptions = [];

		burgerMenuOptions = [
			{
				id: 'group_by_people_enable',
				type: ELEMENT_TYPE.TOGGLE_SWITCH,
				name: formatMessage({id: 'common.group_by_people_enable'}),
				activated: localStorage.getItem('group_by_people_enable') ? JSON.parse(localStorage.getItem('group_by_people_enable')) : Util.localStorageSetItem('group_by_people_enable', false),
			},
			{
				id: 'persons_grouping_show_all',
				type: ELEMENT_TYPE.TOGGLE_SWITCH,
				name: formatMessage({id: 'common.persons_grouping_show_all'}),
				activated: localStorage.getItem('persons_grouping_show_all') ? JSON.parse(localStorage.getItem('persons_grouping_show_all')) : Util.localStorageSetItem('persons_grouping_show_all', false),
			},
		];

		let filters;
		let filtersKey = 'project-scoping-filters-v4-';

		if (localStorage.getItem(`${filtersKey}${this.props.viewer.project.id}`)) {
			filters = JSON.parse(localStorage.getItem(`${filtersKey}${this.props.viewer.project.id}`));
		} else {
			filters = {
				person: {},
				task: {},
			};
		}
		const filterFunctions = getFilterFunctions(filters);
		return {
			tableMinWidth: 0,
			showEmptyPersons: false,
			groupByPerson: JSON.parse(localStorage.getItem('project-scoping-group-by-person')),
			groupByRole: JSON.parse(localStorage.getItem('project-scoping-group-by-role')),
			showPeriods: localStorage.getItem('project-scoping-show-periods') ? JSON.parse(localStorage.getItem('project-scoping-show-periods')) : false,
			showEmptyPeriods: localStorage.getItem('project-scoping-show-empty-periods') ? JSON.parse(localStorage.getItem('project-scoping-show-empty-periods')) : true,
			hasScroll: false,
			selectedTasks: [],
			projectTotalExpanded: true,
			selectionMode: false,
			burgerMenuOptions: burgerMenuOptions,
			dragAndDropGroup: 'project-scoping',
			focusPhaseId: null,
			tasksBeingDragged: [],
			taskAboveId: null,
			draggingTask: false,
			filters,
			filterFunctions,
			phaseFilterValue: (JSON.parse(localStorage.getItem('project-phases-filter-value-' + props.viewer.project.id + '-phase')) || []).filter(val => val !== null),
			statusFilterValue: (JSON.parse(localStorage.getItem('project-phases-filter-value-' + props.viewer.project.id + '-status')) || []).filter(val => val !== null),
			labelFilterValue: (JSON.parse(localStorage.getItem('project-phases-filter-value-' + props.viewer.project.id + '-label')) || []).filter(val => val !== null),
			roleFilterValue: (JSON.parse(localStorage.getItem('project-phases-filter-value-' + props.viewer.project.id + '-role')) || []).filter(val => val !== null),
			blocked_bugFilterValue: (JSON.parse(localStorage.getItem('project-phases-filter-value-' + props.viewer.project.id + '-blocked_bug')) || []).filter(val => val !== null),
			sprintFilterValue: (JSON.parse(localStorage.getItem('project-phases-filter-value-' + props.viewer.project.id + '-sprint')) || []).filter(val => val !== null),
			recentlyUpdatedFilterValue: (JSON.parse(localStorage.getItem('project-phases-filter-value-' + props.viewer.project.id + '-recentlyUpdated')) || []).filter(val => val !== null),
			teamFilterValue: (JSON.parse(localStorage.getItem('project-phases-filter-value-' + props.viewer.project.id + '-team')) || []).filter(val => val !== null),
			teammemberFilterValue: (JSON.parse(localStorage.getItem('project-phases-filter-value-' + props.viewer.project.id + '-teammember')) || []).filter(val => val !== null),
			searchFilterValue: '',
			//showPrice: localStorageColumns.find(column => column.name === 'price') ? localStorageColumns.find(column => column.name === 'price').checked : true,
			//showCurrentPrice: localStorageColumns.find(column => column.name === 'currentPrice') ? localStorageColumns.find(column => column.name === 'currentPrice').checked : true,
			phasesOrderMap: phasesOrderMap,
			availableColumns: this.getInitialSelectedColumns(),
			columnWidths: 0,
			selectedTab: this.getInitialSelectedTab(),
			phasesMap: new Map(),
			collapseAll: true,
			containerWidth: this.getContainerWidth(),
			showBaselineInfo:
				this.props.viewer.project.estimationUnit === constants.ESTIMATION_UNIT.HOURS && Util.isBaselineProject(this.props.viewer.company.modules, this.props.viewer.project)
					? JSON.parse(localStorage.getItem('project-phases-show-baseline-info' + props.viewer.project.companyProjectId)) || true
					: false,
			lazyDataFetched: true,
		};
	}

	getInitialSelectedColumns() {
		const storedCols = JSON.parse(localStorage.getItem('project-scoping-selected-cols'));
		const hasFinancialAccess = Util.hasFinance(this.props.viewer.company.modules) && (hasSomePermission([PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION, PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE]));
		const sprintsEnabled = this.props.viewer.project && this.props.viewer.project.sprintTimeBox;
		const isFixedPrice = this.props.viewer.project && this.props.viewer.project.budgetType === BUDGET_TYPE.FIXED_PRICE_V2;
		const isEstimatedInNewPoints = this.props.viewer.project.estimationUnit === 'POINTS';
		const availableCols = Util.getTaskTableColumns('SCOPING', false, hasFinancialAccess, sprintsEnabled, this.props.viewer.availableFeatureFlags, isEstimatedInNewPoints, isFixedPrice);
		// Replace localStorage if the stored columns differ in length, or if their IDs are different
		const shouldReplace = (stored, avail) => stored.length !== avail.length || stored.filter((c, i) => c.id !== avail[i].name).length > 0;

		if (storedCols) {
			for (let i = 0; i < availableCols.length; i++) {
				const col = availableCols[i];
				const storedCol = storedCols.find(storedCol => storedCol.id === col.name);
				if (!col.hide) {
					availableCols[i].checked = storedCol ? !!storedCol.checked : !!col.scopingDefault;
				}
			}
			if (shouldReplace(storedCols, availableCols)) {
				Util.localStorageSetItem(
					'project-scoping-selected-cols',
					JSON.stringify(
						availableCols.map(c => {
							return {
								id: c.name,
								checked: c.checked,
							};
						})
					)
				);
			}
		} else {
			// Uncheck non-defaults
			availableCols.forEach(col => {
				if (!col.scopingDefault) {
					col.checked = false;
				}
			});
		}

		//If no time registration is enabled, remove related columns
		if (hasFeatureFlag('no_time_reg')) {
			return Util.getNoTimeRegColumns(availableCols);
		}

		return availableCols;
	}

	getInitialSelectedTab() {
		const storedTab = localStorage.getItem('project-scoping-selected-tab');
		if (storedTab) {
			return tabs.find(tab => tab.value === storedTab);
		} else return tabs[0];
	}

	getColWidths(cols) {
		const numActiveCols = cols ? cols.filter(col => col.checked).length : this.state.availableColumns.filter(col => col.checked).length;
		return 100 / numActiveCols;
	}

	shouldMilestoneStartClosed(map) {
		for (let v of map.values()) {
			if (v) {
				return true;
			}
		}
		return false;
	}

	showAutomateModal(variant) {
		showModal({
			type: MODAL_TYPE.PROJECT_AUTOMATE,
			variant: variant,
			tasks: this.state.selectedTasks.map(task => task.node),
			intl: this.props.intl,
			allProjects: this.props.viewer.projects,
			currentProject: this.props.viewer.project,
			labels: this.props.viewer.company.labels,
			roles: this.props.viewer.company.roles,
			persons: this.props.viewer.project.projectPersons.edges.map(edge => edge.node.person),
		});
	}

	shouldPhaseStartClosed(phase) {
		let shouldStartClosed = false;
		if (phase.deadlineDay) {
			const phaseDeadlineDate = Util.CreateNonUtcMomentDate(phase.deadlineYear, phase.deadlineMonth, phase.deadlineDay);
			if (Moment().isAfter(phaseDeadlineDate) && phase.tasks.filter(task => task.statusColumnV2.category !== WorkflowCategories.DONE).length === 0) {
				shouldStartClosed = true;
			}
		}
		return shouldStartClosed;
	}

	colsDidChange(prevCols, newCols) {
		const newColsList = Object.values(newCols);
		const prevColsList = Object.values(prevCols);
		return prevColsList.filter((col, index) => col.checked !== newColsList[index].checked).length > 0;
	}

	/*calculateTablesSize() {
		// 22 px for 10 of padding and 1 border from each side + table 16 padding from each side + 160 (approved and add cols) = 214
		const tableWidth = this.section_body ? this.section_body.offsetWidth - 214 : 0;
		const checkedColNr = this.state.display.filter(el => el.checked).length + 3;
		let display = JSON.parse(JSON.stringify(this.state.display));
		let spaceLeft = tableWidth - display.filter(el => el.checked).reduce((total, el) => total + el.minWidth, 0);
		display.forEach(el => {
			if (el.checked) {
				if (spaceLeft > 0) {
					if (el.name === 'title') {
						el.width = el.minWidth + (spaceLeft * 20) / 100;
					} else if (el.name === 'low-estimate' || el.name === 'high-estimate' || el.name === 'role') {
						el.width = el.minWidth + (spaceLeft * 10) / 100;
					} else {
						// minus title which always takes 80% of available space. Rest of 20% must redistributed betwen checked columns equally
						const percentageAvailable = 50 / (checkedColNr - 1);
						el.width = el.minWidth + (spaceLeft * percentageAvailable) / 100;
					}
				} else {
					el.width = el.minWidth;
				}
			}
		});
		this.setState({display: display});
	}*/

	handleShortcutProjectPhases(e) {
		const taskModalOpen = Util.getPathIsTaskModal();
		const activeElement = document.activeElement;
		const focusIsInput =
			activeElement &&
			(activeElement.tagName === 'INPUT' ||
				activeElement.tagName === 'TEXTAREA' ||
				activeElement.isContentEditable ||
				(activeElement.className && activeElement.className.toLowerCase().includes('drafteditor')) ||
				(activeElement.className && activeElement.className.toLowerCase().includes('switch')));

		if (taskModalOpen || focusIsInput || e.repeat) {
			return;
		}
		if (e.shiftKey && !e.altKey && e.key === 'G') {
			e.preventDefault();
			this.toggleGroupByPerson();
		}
		if (e.shiftKey && !e.altKey && e.key === 'E' && this.state.groupByPerson) {
			e.preventDefault();
			this.toggleShowEmptyPersons();
		}
		if (e.shiftKey && !e.altKey && e.key === 'N') {
			e.preventDefault();
			this.addPhase();
		}
		if (e.key === 'Enter' && e.ctrlKey) {
			this.toggleCollapseAll();
		}
		if (e.key === 'Escape') {
			if (this.state.selectedTasks.length > 0) {
				this.unselectTasks();
			}
		}
		if (e.altKey && e.shiftKey && e.keyCode === 88) {
			this.clearFilters();
		}
	}

	handleFilterChange(filterType, value) {
		this.setState({[filterType + 'FilterValue']: value});
		if (typeof value === 'string') {
			Util.localStorageSetItem('project-phases-filter-value-' + this.props.viewer.project.id + '-' + filterType, JSON.stringify(value));
		} else {
			Util.localStorageSetItem('project-phases-filter-value-' + this.props.viewer.project.id + '-' + filterType, JSON.stringify(value.map(v => ({...v, label: null}))));
		}
	}

	updateSelectionMode(selectedTaskCount) {
		this.setState({
			selectionMode: selectedTaskCount > 0,
		});
	}

	unselectTasks() {
		this.setState({selectedTasks: []});
		this.updateSelectionMode(0);
	}

	addPhase() {
		const onSuccess = result => {
			this.isCreatingPhase = false;
			const phasesOrderMap = new Map();
			const phasesMap = this.state.phasesMap;
			phasesOrderMap.set(result.createPhase.phase.node.id, 0);
			phasesMap.set(result.createPhase.phase.node.id, true);
			this.state.phasesOrderMap.forEach((value, key, map) => {
				phasesOrderMap.set(key, value + 1);
			});
			this.setState({focusPhaseId: result.createPhase.phase.node.id, phasesOrderMap: phasesOrderMap, phasesMap: phasesMap});
			createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'project_scopes.scope-group-created'})});
			//scroll to the new milestone
		};
		//const formattedDeadline = Util.GetYearMonthDateFromMomentDate(deadline);
		if (!this.isCreatingPhase) {
			this.isCreatingPhase = true;
			Util.CommitMutation(
				CreatePhaseMutation,
				{
					projectId: this.props.viewer.project.id,
					name: this.props.intl.formatMessage({id: 'project_scoping.new-scope-group'}),
				},
				onSuccess
			);
		}
	}

	scrollToNewMilestone(newMilestoneId) {
		if (this.scrollbar) {
			if (newMilestoneId) {
				requestAnimationFrame(() => {
					const el = document.getElementById('phase-wrapper-' + newMilestoneId);

					if (el) {
						this.scrollbar.animateScrollTop(el.offsetTop - 20);
						this.scrollbar.scrollToLeft();
					}
				});
			} else {
				this.scrollbar.scrollTop(0);
			}
		}
	}

	clearFilters() {
		this.setState({
			phaseFilterValue: [],
			statusFilterValue: [],
			labelFilterValue: [],
			recentlyUpdatedFilterValue: [],
			teammemberFilterValue: [],
			roleFilterValue: [],
			sprintFilterValue: [],
			teamFilterValue: [],
			blocked_bugFilterValue: [],
			searchFilterValue: '',
			selectedTasks: [],
		});

		localStorage.removeItem('project-phases-filter-value-' + this.props.viewer.project.id + '-status');
		localStorage.removeItem('project-phases-filter-value-' + this.props.viewer.project.id + '-phase');
		localStorage.removeItem('project-phases-filter-value-' + this.props.viewer.project.id + '-label');
		localStorage.removeItem('project-phases-filter-value-' + this.props.viewer.project.id + '-role');
		localStorage.removeItem('project-phases-filter-value-' + this.props.viewer.project.id + '-sprint');
		localStorage.removeItem('project-phases-filter-value-' + this.props.viewer.project.id + '-recentlyUpdated');
		localStorage.removeItem('project-phases-filter-value-' + this.props.viewer.project.id + '-blocked_bug');
		localStorage.removeItem('project-phases-filter-value-' + this.props.viewer.project.id + '-team');
		localStorage.removeItem('project-phases-filter-value-' + this.props.viewer.project.id + '-teammember');
	}

	/*handleDisplayChange(selected) {
		const stateDisplay = JSON.parse(JSON.stringify(this.state.display));
		const column = stateDisplay.find(column => column.name === selected.name);
		if (column) column.checked = !column.checked;
		Util.localStorageSetItem('columns-project-phases', JSON.stringify(stateDisplay));
		if (selected.name === 'price') {
			this.setState({display: stateDisplay, showPrice: !selected.checked});
		} else if (selected.name === 'currentPrice') {
			this.setState({display: stateDisplay, showCurrentPrice: !selected.checked});
		} else {
			this.setState({display: stateDisplay});
		}
	}*/

	bulkUpdateAssign() {
		Util.localStorageDeleteFincancialMap();
		const callbackPositive = selected => {
			const onSuccess = result => {
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'bulk_update.toast'})});
			};
			const assignedPersons = selected.map(el => el.value);
			Util.CommitMutation(
				UpdateTaskMutation,
				{
					ids: this.state.selectedTasks.map(t => t.node.id),
					assignedPersons: assignedPersons,
				},
				onSuccess
			);
		};
		const person_options = this.props.viewer.project
			? this.props.viewer.project.projectPersons.edges.map(pp => ({
					value: pp.node.person.id,
					label: pp.node.person.firstName + ' ' + pp.node.person.lastName,
					profilePictureId: pp.node.person.profilePictureId,
					profilePictureDefaultId: pp.node.person.profilePictureDefaultId,
					initials: pp.node.person.initials,
			  }))
			: this.props.viewer.projectGroup.projects.edges[0].node.projectPersons.edges
					.filter(pp => !personIsClientUser(pp.node.person))
					.map(pp => ({
						value: pp.node.person.id,
						label: pp.node.person.firstName + ' ' + pp.node.person.lastName,
						profilePictureId: pp.node.person.profilePictureId,
						profilePictureDefaultId: pp.node.person.profilePictureDefaultId,
						initials: pp.node.person.initials,
					}));
		showModal({
			type: MODAL_TYPE.SELECT,
			title: this.props.intl.formatMessage({id: 'common.assign_to'}),
			defaultCallback: callbackPositive,
			options: person_options,
			label: this.props.intl.formatMessage({id: 'common.assigned'}),
			multi: true,
			initialValue: [],
			personSelect: true,
		});
	}

	bulkUpdateMoveToPhase() {
		const callbackPositive = selected => {
			const onSuccess = result => {
				//this.setState({selectedTasks: []});
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'bulk_update.toast'})});
			};
			Util.CommitMutation(
				UpdateTaskMutation,
				{
					ids: this.state.selectedTasks.map(t => t.node.id),
					phaseId: selected ? selected.value : null,
				},
				onSuccess
			);
		};
		const phase_select_options = this.props.viewer.project.phases.edges.map(phase => ({value: phase.node.id, label: phase.node.name}));
		showModal({
			type: MODAL_TYPE.SELECT_V2,
			title: this.props.intl.formatMessage({id: 'project_section.bulk_move_cards_milesone'}),
			defaultCallback: callbackPositive,
			options: phase_select_options,
			label: this.props.intl.formatMessage({id: 'common.scope-group'}),
			multi: false,
			initialValue: null,
		});
	}

	bulkUpdateStatus() {
		const callbackPositive = selected => {
			const onSuccess = result => {
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'bulk_update.toast'})});
			};
			const mutationObject = {
				ids: this.state.selectedTasks.map(t => t.node.id),
			};
			mutationObject.statusColumnId = selected ? selected.value : null;
			Util.CommitMutation(UpdateTaskMutation, mutationObject, onSuccess);
		};
		const status_select_options = cloneDeep(this.props.viewer.project.statusColumnsV2.edges)
			.sort((a, b) => a.node.order - b.node.order)
			.map(col => ({value: col.node.id, label: col.node.name}));
		showModal({
			type: MODAL_TYPE.SELECT_V2,
			title: this.props.intl.formatMessage({id: 'bulk_update_option.move_to_status'}),
			defaultCallback: callbackPositive,
			options: status_select_options,
			label: this.props.intl.formatMessage({id: 'common.status'}),
			multi: false,
			initialValue: null,
		});
	}

	bulkUpdateSprint() {
		const callbackPositive = selected => {
			const onSuccess = result => {
				createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'bulk_update.toast'})});
			};
			const mutationObject = {
				ids: this.state.selectedTasks.map(t => t.node.id),
			};
			if (this.props.viewer.project || !selected) {
				mutationObject.sprintId = selected ? selected.value : null;
			} else {
				mutationObject.projectGroupSprintId = selected.value;
			}
			Util.CommitMutation(UpdateTaskMutation, mutationObject, onSuccess);
		};
		const sprint_select_options = cloneDeep(this.props.viewer.project.sprints.edges)
			.sort(this.compareSprintDates)
			.map(sprint => ({value: sprint.node.id, label: sprint.node.name}));
		sprint_select_options.push({value: null, label: this.props.intl.formatMessage({id: 'project_sprints.backlog'})});
		showModal({
			type: MODAL_TYPE.SELECT_V2,
			title: this.props.intl.formatMessage({id: 'project_section.bulk_move_cards_sprint'}),
			defaultCallback: callbackPositive,
			options: sprint_select_options,
			label: this.props.intl.formatMessage({id: 'common.sprint'}),
			multi: false,
			initialValue: null,
		});
	}

	bulkUpdateMoveToProject() {
		const currentProjectId = this.props.viewer.project.id;
		const selectedTaskIds = this.state.selectedTasks.map(task => task.node.id);
		showModal({
			type: MODAL_TYPE.TASK_LOCATION,
			currentProjectId: currentProjectId,
			taskId: selectedTaskIds,
			onSuccess: () => {
				if (this.fixedPriceUtil) {
					this.fixedPriceUtil.deleteTasks(selectedTaskIds);
				}
			},
		});

		this.unselectTasks();
	}

	bulkUpdateTask() {
		const onSuccess = (errors, result) => {
			if (errors && errors.length !== 0) {
				Util.resolveTaskStatusErrors(errors, this.props.intl);
			} else {
				if (this.fixedPriceUtil && result && result.updateTask && result.updateTask.tasks) {
					this.fixedPriceUtil.updateTasks(result.updateTask.tasks);
				}
			}
			/*else {
				this.setState({selectedTasks: []});
			}*/
		};
		const role_options = this.props.viewer.company.roles.edges.map(role => ({value: role.node.id, label: role.node.name}));
		const people_options = this.props.viewer.project.projectPersons.edges.map(pp => ({
			value: pp.node.person.id,
			label: pp.node.person.firstName + ' ' + pp.node.person.lastName,
			profilePictureId: pp.node.person.profilePictureId,
			profilePictureDefaultId: pp.node.person.profilePictureDefaultId,
		}));
		const status_options = this.props.viewer.project.statusColumnsV2.edges.map(col => ({value: col.node.id, label: col.node.name, logo: col.node.jiraStatusId ? 'jira-logo' : undefined}));
		const labels_options = this.props.viewer.company.labels.edges.map(label => ({value: label.node.id, label: label.node.name, color: label.node.color}));
		showModal({
			type: MODAL_TYPE.BULK_TASK_UPDATE,
			language: this.props.viewer.language,
			useTaskFollowers: this.props.viewer.project.useTaskFollowers,
			role_options: role_options,
			people_options: people_options,
			status_options: status_options,
			labels_options: labels_options,
			companyId: this.props.viewer.company.id,
			tasks: this.state.selectedTasks.map(t => t.node.id),
			estimationUnit: this.props.viewer.project.estimationUnit,
			removeLowHigh: this.props.viewer.project.estimationUnit === 'POINTS' || this.props.viewer.availableFeatureFlags.some(flag => flag.key === 'remove_low_high'),
			saveCallback: onSuccess,
			isJiraProject: this.props.viewer.project.isJiraProject,
			availableFeatureFlags: this.props.viewer.availableFeatureFlags,
		});
	}

	bulkUpdateDelete() {
		const {formatMessage} = this.props.intl;
		const selectedTasks = this.state.selectedTasks;
		if (this.props.viewer.timerStartDate) {
			for (let task of selectedTasks) {
				if (this.props.viewer.timerTask && task.node.id === this.props.viewer.timerTask.id) {
					this.stopTimer(task.node, true);
					return;
				}
			}
		}
		const callbackPositive = () => {
			const onSuccess = result => {
				this.unselectTasks();
				createToast({duration: 5000, message: formatMessage({id: 'bulk_delete.toast'})});
			};

			if (this.fixedPriceUtil) {
				const taskIds = this.state.selectedTasks.map(taskEdge => taskEdge.node.id);
				this.fixedPriceUtil.deleteTasks(taskIds);
			}

			Util.CommitMutation(DeleteTaskMutation, {projectId: this.props.viewer.project.id, ids: this.state.selectedTasks.map(t => t.node.id)}, onSuccess);
		};
		showModal({
			type: MODAL_TYPE.GENERIC_DELETION_WARNING,
			deletedItems: this.state.selectedTasks.map(task => task.node),
			deleteCallback: callbackPositive,
		});
	}

	stopTimer(task, preventedDelete) {
		const project = this.props.viewer.project ? this.props.viewer.project : this.props.viewer.projectGroup.projects.edges.find(edge => edge.node.tasks.edges.find(taskEdge => taskEdge.node.id === task.id)).node;
		showModal({
			type: MODAL_TYPE.TIMER_V3,
			isPreviousTimerReminder: false,
			timerProject: project,
			timerTask: task,
			preventedDelete: preventedDelete,
		});
	}

	setShouldCollapseAll() {
		const map = this.state.phasesMap;
		// If any milestone is expanded: collapse all; otherwise expand all
		const shouldClose = !![...map.values()].find(bool => bool);
		if (this.state.collapseAll !== shouldClose) {
			this.setState({collapseAll: shouldClose});
		}
	}

	toggleSelectionMode(rowId) {
		const curSelection = this.state.selectionMode;
		const mutationObject = {};
		const shouldActivateWithTask = rowId != null;
		if (shouldActivateWithTask) {
			if (!this.state.selectionMode) {
				mutationObject.selectionMode = true;
			}
		} else {
			mutationObject.selectionMode = !curSelection;
		}
		if (this.state.selectedTasks.length > 0) {
			mutationObject.selectedTasks = [];
		}
		if (this.state.selectionMode) {
			tracking.trackPageAction(`Bulk-edit-mode-on`);
		}
		this.setState(mutationObject, () => (rowId != null ? this.handleRowSelected(rowId, false) : null));
	}

	toggleCollapseAll() {
		const map = this.state.phasesMap;
		map.forEach((v, k) => map.set(k, !this.state.collapseAll));
		Util.localStorageSetItem(this.props.viewer.project.id + '-map', JSON.stringify(map));
		this.setState(prevState => {
			return {phasesMap: map};
		});
	}

	toggleBurgerMenu() {}

	handleSwitchOption(option) {
		const optionsSelected = this.state.burgerMenuOptions.map(opt => {
			if (opt.id === option.id) {
				opt.activated = !opt.activated;
				Util.localStorageSetItem(opt.id, opt.activated);
			}
			return opt;
		});

		this.setState({
			burgerMenuOptions: optionsSelected,
		});
	}

	getIsPhaseExpanded(phaseId) {
		const map = this.state.phasesMap; //new Map(JSON.parse(localStorage.getItem(this.props.viewer.project + '-map')));
		return map.get(phaseId) == null || map.get(phaseId);
	}

	togglePhaseExpanded(phaseId) {
		const map = this.state.phasesMap; //new Map(JSON.parse(localStorage.getItem(this.props.viewer.project + '-map')));
		const curVal = map.get(phaseId);
		map.set(phaseId, !curVal);
		Util.localStorageSetItem(this.props.viewer.project.id + '-map', JSON.stringify(map));
		this.setState({phasesMap: map});
	}

	theEyeSelector(selectedElem) {
		const cols = this.state.availableColumns;
		cols.forEach(elem => {
			if (elem.name === selectedElem.name) {
				elem.checked = !elem.checked;
			}
		});

		// custom logic for showing base line info.
		// this is project specific, and not a global setting
		// that is why we save it in its own localStorage
		let baseLineInfoOption = this.state.showBaselineInfo;

		if (selectedElem.name === 'show-scoping-baseline-info') {
			baseLineInfoOption = !this.state.showBaselineInfo;
		}
		const width = this.getColWidths(cols);
		cols.map(col => (col.width = width));
		this.setState({availableColumns: cols, columnWidths: width, showBaselineInfo: baseLineInfoOption});

		const theEye = cols.map(c => {
			return {
				id: c.name,
				checked: c.checked,
			};
		});

		Util.localStorageSetItem('project-phases-show-baseline-info', baseLineInfoOption);
		Util.localStorageSetItem('project-scoping-selected-cols', JSON.stringify(theEye));
		tracking.trackEyeSelector(
			cols
				.filter(elem => elem.name !== 'chip-right' && elem.name !== 'selector' && elem.name !== 'task-name')
				.map(c => {
					return {
						name: c.name,
						checked: c.checked,
					};
				})
		);
		this.updateTaskCellMaxWidth();
	}

	toggleShowEmptyPersons() {
		this.setState(prevState => {
			return {showEmptyPersons: !prevState.showEmptyPersons};
		});

		tracking.trackElementClicked('Show empty persons', {enabled: this.state.showEmptyPersons});
	}

	toggleGroupByPerson() {
		this.setState(
			prevState => {
				return {groupByPerson: !prevState.groupByPerson, groupByRole: false};
			},
			() => {
				Util.localStorageSetItem('project-scoping-group-by-person', this.state.groupByPerson);
				Util.localStorageSetItem('project-scoping-group-by-role', false);
			}
		);

		tracking.trackElementClicked('Group by person', {enabled: this.state.groupByPerson});
	}

	toggleGroupByRole() {
		this.setState(
			prevState => {
				return {groupByRole: !prevState.groupByRole, groupByPerson: false};
			},
			() => {
				Util.localStorageSetItem('project-scoping-group-by-role', this.state.groupByRole);
				Util.localStorageSetItem('project-scoping-group-by-person', false);
			}
		);

		tracking.trackElementClicked('Group by role', {enabled: this.state.groupByRole});
	}

	toggleShowPeriods() {
		this.setState(
			prevState => {
				return {showPeriods: !prevState.showPeriods};
			},
			() => Util.localStorageSetItem('project-scoping-show-periods', this.state.showPeriods)
		);

		tracking.trackElementClicked('Show Periods', {enabled: this.state.showPeriods});
	}

	toggleShowEmptyPeriods() {
		this.setState(
			prevState => {
				return {showEmptyPeriods: !prevState.showEmptyPeriods};
			},
			() => Util.localStorageSetItem('project-scoping-show-empty-periods', this.state.showEmptyPeriods)
		);

		tracking.trackElementClicked('Show Empty Periods', {enabled: this.state.showEmptyPeriods});
	}

	handleTabChange(tab) {
		this.setState({selectedTab: tab});
		Util.localStorageSetItem('project-scoping-selected-tab', tab.value);

		tracking.trackElementClicked(tab.value + ' milestones');
	}

	onFilterChange(filters, filterFunctions) {
		this.setState({filters, filterFunctions});
	}

	//can be removed once we stop using old filters
	fillOldFilterOptions() {
		const {formatMessage} = this.props.intl;
		//Fill teammember filter options
		const teammemberFilterOptions = [];
		const projectPersons = this.props.viewer.project.projectPersons.edges;
		projectPersons.forEach(teammember => {
			const searchString = teammember.node.person.firstName + ' ' + teammember.node.person.lastName;
			return teammemberFilterOptions.push({
				value: teammember.node.person.id,
				searchString,
				label: <FilterPerson person={teammember.node.person} negativeMargin={true} />,
			});
		});
		teammemberFilterOptions.unshift({value: null, label: formatMessage({id: 'cards.unassigned'})});

		//Fill phase filter options
		const phaseFilterOptions = this.props.viewer.project.phases.edges.map(phase => {
			return {value: phase.node.id, label: phase.node.name};
		});
		phaseFilterOptions.unshift({value: null, label: formatMessage({id: 'project_scopes.no-scope'})});

		const statusFilterOptions = cloneDeep(this.props.viewer.project.statusColumnsV2.edges)
			.sort((a, b) => a.node.order - b.node.order)
			.map(status => {
				return {value: status.node.id, label: status.node.name};
			});

		const labelFilterOptions = [];
		cloneDeep(this.props.viewer.company.labels.edges)
			.sort((a, b) => {
				if (a.node.name.toLowerCase() < b.node.name.toLowerCase()) return -1;
				if (a.node.name.toLowerCase() > b.node.name.toLowerCase()) return 1;
				return 0;
			})
			.forEach(label => {
				labelFilterOptions.push({
					value: label.node.id,
					label: label.node.name,
				});
			});
		const roleFilterOptions = this.props.viewer.company.roles.edges.map(role => {
			return {value: role.node.id, label: role.node.name};
		});
		roleFilterOptions.unshift({value: null, label: formatMessage({id: 'card_modal.no-role'})});
		const blockedBugFilterOptions = Util.GetIndicatorFilters(
			formatMessage({id: 'common.blocked'}),
			formatMessage({id: 'common.bug'}),
			formatMessage({id: 'common.dependencies'}),
			formatMessage({id: 'common.warning'}),
			formatMessage({id: 'common.critical'}),
			formatMessage({id: 'common.high_priority'})
		);
		const sprintFilterOptions = this.props.viewer.project.sprints.edges.map(sprint => {
			return {value: sprint.node.id, label: sprint.node.name};
		});

		const recentUpdateOptions = Util.getRecentUpdateFilters(this.props.intl);

		sprintFilterOptions.unshift({value: null, label: formatMessage({id: 'project_sprints.backlog'})});
		const teamFilterOptions = this.props.viewer.company.teams.edges.map(team => ({value: team.node.id, label: team.node.name}));
		const filters = [
			{
				options: sprintFilterOptions,
				onChange: this.handleFilterChange.bind(this, 'sprint'),
				value: this.state.sprintFilterValue,
				placeholder: formatMessage({id: 'common.filter-by-sprint'}),
				label: formatMessage({id: 'common.sprint'}),
			},
			{
				options: recentUpdateOptions,
				onChange: this.handleFilterChange.bind(this, 'recentlyUpdated'),
				value: this.state.recentlyUpdatedFilterValue,
				placeholder: formatMessage({id: 'common.filter_by_recently_updated'}),
				label: formatMessage({id: 'common.recently_updated'}),
			},
			{
				options: phaseFilterOptions,
				onChange: this.handleFilterChange.bind(this, 'phase'),
				value: this.state.phaseFilterValue,
				placeholder: formatMessage({id: 'common.filter-by-scope-group'}),
				label: formatMessage({id: 'common.scope'}),
			},
			{
				options: teammemberFilterOptions,
				onChange: this.handleFilterChange.bind(this, 'teammember'),
				value: this.state.teammemberFilterValue,
				placeholder: formatMessage({id: 'common.filter-by-teammember'}),
				label: formatMessage({id: 'common.team_member'}),
			},
			{
				options: statusFilterOptions,
				onChange: this.handleFilterChange.bind(this, 'status'),
				value: this.state.statusFilterValue,
				placeholder: formatMessage({id: 'common.filter-by-status'}),
				label: formatMessage({id: 'common.status'}),
			},
			{
				options: roleFilterOptions,
				onChange: this.handleFilterChange.bind(this, 'role'),
				value: this.state.roleFilterValue,
				placeholder: formatMessage({id: 'common.filter-by-role'}),
				label: formatMessage({id: 'common.role'}),
			},
			{
				options: labelFilterOptions,
				onChange: this.handleFilterChange.bind(this, 'label'),
				value: this.state.labelFilterValue,
				placeholder: formatMessage({id: 'common.filter-by-label'}),
				label: formatMessage({id: 'common.label'}),
			},
			{
				options: blockedBugFilterOptions,
				onChange: this.handleFilterChange.bind(this, 'blocked_bug'),
				value: this.state.blocked_bugFilterValue,
				placeholder: formatMessage({id: 'common.filter_by_indicator'}),
				label: formatMessage({id: 'common.filter_title.indicator'}),
			},
			{
				options: teamFilterOptions,
				onChange: this.handleFilterChange.bind(this, 'team'),
				value: this.state.teamFilterValue,
				placeholder: formatMessage({id: 'common.filter_by_team'}),
				label: formatMessage({id: 'common.team'}),
			},
		];
		return filters;
	}

	onAutoScheduleButtonClicked = () => {
		tracking.trackElementClicked('Auto Schedule project from the Scoping page');
		//  open new tab on the project timeline and with the autoschedule modal
		window.open(`${constants.projectUrl(this.props.viewer.project.companyProjectId)}/schedule#auto-schedule`);
	};

	getBulkUpdateOptions() {
		const invoiced = this.state.selectedTasks && this.state.selectedTasks.some(task => task.node.hasInvoicedTime);
		const lockedTimeReg = this.state.selectedTasks && this.state.selectedTasks.some(task => task.node.hasLockedTime);
		const selectionHasBlockingTask = this.state.selectedTasks.some(t => !t.node.userCanDeleteTask);

		if (this.props.viewer.project.isJiraProject) {
			let list = [
				{
					id: 'bulk update',
					label: this.props.intl.formatMessage({id: 'project_section.bulk_card_update'}),
					icon: color => <MoreActionsOutline color={color} width={16} height={16} />,
					callback: this.bulkUpdateTask.bind(this),
					userpilot: 'bulk-update-button',
					cy: 'bulk-update-button',
					variant: BUTTON_VARIANT.VERY_LIGHT_GRAY_OUTLINE,
				},
			];
			if (!isClientUser()) {
				list.push({
					id: 'move_tasks',
					label: this.props.intl.formatMessage({id: 'bulk_edit.move_tasks'}),
					icon: color => <ArrowRightOutline color={color} width={16} height={16} />,
					options: [{label: this.props.intl.formatMessage({id: 'project_section.bulk_move_cards_milesone'}), callback: this.bulkUpdateMoveToPhase.bind(this)}],
					userpilot: 'bulk-move-button',
					cy: 'bulk-move-button',
					variant: BUTTON_VARIANT.VERY_LIGHT_GRAY_OUTLINE,
				});

				return list;
			}
		} else {
			let list = [
				{
					id: 'bulk update',
					label: this.props.intl.formatMessage({id: 'project_section.bulk_card_update'}),
					icon: color => <MoreActionsOutline color={color} width={16} height={16} />,
					callback: this.bulkUpdateTask.bind(this),
					userpilot: 'bulk-update-button',
					cy: 'bulk-update-button',
					variant: BUTTON_VARIANT.VERY_LIGHT_GRAY_OUTLINE,
				},
			];

			if (!isClientUser()) {
				list.push({
					id: 'move_tasks',
					label: this.props.intl.formatMessage({id: 'bulk_edit.move_tasks'}),
					icon: color => <ArrowRightOutline color={color} width={16} height={16} />,
					options: [
						{label: this.props.intl.formatMessage({id: 'bulk_update_option.move_to_status'}), callback: this.bulkUpdateStatus.bind(this)},
						{label: this.props.intl.formatMessage({id: 'bulk_update_option.move_to_sprint'}), callback: this.bulkUpdateSprint.bind(this)},
						{label: this.props.intl.formatMessage({id: 'project_section.bulk_move_cards_milesone'}), callback: this.bulkUpdateMoveToPhase.bind(this)},
						{label: this.props.intl.formatMessage({id: 'task_location_modal.title'}), callback: this.bulkUpdateMoveToProject.bind(this), disabled: invoiced || lockedTimeReg},
					],
					userpilot: 'bulk-move-button',
					cy: 'bulk-move-button',
					variant: BUTTON_VARIANT.VERY_LIGHT_GRAY_OUTLINE,
				});
			}

			list.push({
				id: 'delete',
				icon: color => <BinOutline color={color} width={16} height={16} />,
				label: this.props.intl.formatMessage({id: 'common.delete'}),
				callback: this.bulkUpdateDelete.bind(this),
				disabled: selectionHasBlockingTask || invoiced || lockedTimeReg,
				userpilot: 'bulk-delete-button',
				cy: 'bulk-delete-button',
				variant: BUTTON_VARIANT.VERY_LIGHT_GRAY_OUTLINE,
			});

			return list;
		}
	}

	getHeaderTitle() {
		const content = [];
		const onboardingFlows = [
			{
				id: 'scoping-introduction',
				title: 'Scoping Intro',
				description: null,
				contentId: '1594304052lNpm0692',
			},
			{id: 'scoping-first-milestone', title: 'Scoping - Scoping out your first Milestone', description: null, contentId: '1594304249aHmt209'},
			{id: 'scoping-best-practices', title: 'Scoping - Tips and Tricks', description: null, contentId: '1594304278jNny2762'},
		];

		const onboardingComponent = {
			id: 'onboarding-component',
			intl: this.props.intl,
			type: TopHeaderBar.TYPE.ONBOARDING,
			title: this.props.intl.formatMessage({id: 'onboarding.scoping_onboarding_title'}),
			options: onboardingFlows,
		};
		content.push(onboardingComponent);

		if (hasFeatureFlag('new_scoping', this.props.viewer.availableFeatureFlags)) {
			const baseLink = constants.projectUrl(this.props.viewer.project.companyProjectId);
			content.push({
				type: TopHeaderBar.TYPE.DEPRECATED_PAGE,
				text: 'common.page_deprecated',
				link: `${baseLink}/new-scoping`,
			});
		}

		return (
			<TopHeaderBarWrapper sidePadding={66}>
				<TopHeaderBar title={this.props.intl.formatMessage({id: 'project_section.scope'})} content={content} />
			</TopHeaderBarWrapper>
		);
	}

	constructHeaderBar() {
		const parentGroup = this.props.viewer.project && this.props.viewer.project.projectGroupId && this.props.viewer.projectGroups.edges.find(group => group.node.id === this.props.viewer.project.projectGroupId);

		const useThirdLevelNav = hasFeatureFlag('third_level_nav', this.props.viewer.availableFeatureFlags);

		const projectLocked = this.props.viewer.project.status === 'DONE' || this.props.viewer.project.status === 'HALTED';
		const {formatMessage} = this.props.intl;
		const leftContent = [];
		const rightContent = [];

		const autoSchedulingEnabled = !this.props.viewer.project.useManualAllocations && hasPermission(PERMISSION_TYPE.PROJECTS_UPDATE);
		tabs.forEach(tab => {
			tab.label = formatMessage({id: tab.translationId});
		});
		const pastOrActiveMilestone = {
			type: ELEMENT_TYPE.LEFT_DROPDOWN,
			dropdownOptions: tabs,
			value: this.state.selectedTab.value,
			buttonCy: 'new-ui-scoping-milestone-selector-tab',
			listDataCy: 'new-ui-scoping-milestone-selector-options',
			userpilot: 'milestone-dropdown',
			callback: this.handleTabChange.bind(this),
		};
		leftContent.push(pastOrActiveMilestone);
		const theEye = {
			type: ELEMENT_TYPE.THE_EYE,
			options:
				this.props.viewer.project.estimationUnit === constants.ESTIMATION_UNIT.HOURS && Util.isBaselineProject(this.props.viewer.company.modules, this.props.viewer.project)
					? this.state.availableColumns.concat([{name: 'show-scoping-baseline-info', checked: this.state.showBaselineInfo, translationId: 'scoping.show_scoping_baseline_info'}])
					: this.state.availableColumns,
			onSelect: this.theEyeSelector.bind(this),
			openRight: true,
		};
		leftContent.push(theEye);

		const useNewCSVFormat = hasFeatureFlag('new_csv_format', this.props.viewer.availableFeatureFlags);

		const csv = {
			type: ELEMENT_TYPE.CSV,
			callback: useNewCSVFormat ? this.exportCSVNew.bind(this) : this.exportCSV.bind(this),
			style: BUTTON_STYLE.OUTLINE,
			color: BUTTON_COLOR.LIGHTGREY,
			text: formatMessage({id: 'common.export-csv'}),
			tooltipEnabled: true,
			tooltipProps: {
				autoPlace: true,
				grey: true,
				infoText: formatMessage({id: 'common.export-csv'}),
			},
			disabled: !this.state.lazyDataFetched,
		};
		leftContent.push(csv);

		if (projectLocked) {
			const indicator = {
				type: ELEMENT_TYPE.INDICATOR,
				status: this.props.viewer.project.status,
			};
			leftContent.push(indicator);
		}

		// This shouldn't shown yet. But I will leave it here for when "old" Scoping is deprecated
		// if (hasFeatureFlag('new_scoping', this.props.viewer.availableFeatureFlags)) {
		// 	const baseLink = constants.projectUrl(this.props.viewer.project.companyProjectId);
		// 	rightContent.push({
		// 		type: ELEMENT_TYPE.LINK,
		// 		linkText: 'Page deprecated',
		// 		linkUrl: `${baseLink}/new-scoping`,
		// 	});
		// }

		const search = {
			type: ELEMENT_TYPE.SEARCH,
			value: this.state.searchFilterValue,
			onChange: this.handleFilterChange.bind(this, 'search'),
		};

		rightContent.push(search);
		const taskFilters = [
			FILTER_TYPE.PROJECT_PERSON,
			FILTER_TYPE.ROLE,
			FILTER_TYPE.PROJECT_STATUS_COLUMN,
			FILTER_TYPE.APPROUVED,
			FILTER_TYPE.DEADLINE,
			FILTER_TYPE.DEPENDENCIES,
			FILTER_TYPE.INDICATOR,
			FILTER_TYPE.LABEL,
			FILTER_TYPE.PROJECT_PHASE,
			FILTER_TYPE.RECENT_ACTIVITY,
		];

		if (this.props.viewer.company.teams.edges.length > 0) {
			taskFilters.push(FILTER_TYPE.TEAM);
		}

		if (this.props.viewer.project && this.props.viewer.project.sprintTimeBox) {
			taskFilters.push(FILTER_TYPE.PROJECT_SPRINT);
			taskFilters.push(FILTER_TYPE.SPRINT_CATEGORY);
		}

		if (this.props.viewer.project.useTaskOwner) {
			taskFilters.push(FILTER_TYPE.PROJECT_OWNER);
		}

		if (this.props.viewer.project.useTaskFollowers) {
			taskFilters.push(FILTER_TYPE.PROJECT_FOLLOWER);
		}

		if (this.props.viewer.project && this.props.viewer.project.taskLevels === 2) {
			taskFilters.push(FILTER_TYPE.SUB_TASKS);
		}

		const projectFilters = [];
		const peopleFilters = [];
		rightContent.push({
			type: ELEMENT_TYPE.FILTER_V4,
			defaultSection: FILTER_SECTIONS.TASKS,
			projectFilters,
			peopleFilters,
			taskFilters: getFiltersAlphabetically(taskFilters, this.props.intl.formatMessage),
			viewer: this.props.viewer,
			appliedFiltersName: `project-scoping-filters-v4-${this.props.viewer.project.id}`,
			filterSection: FILTER_SECTION.SCOPING,
			onFiltersChange: this.onFilterChange.bind(this),
			projectId: this.props.viewer.project.id,
			companyProjectId: this.props.viewer.project ? this.props.viewer.project.companyProjectId : null,
		});

		if (hasPermission(PERMISSION_TYPE.MILESTONE_CREATE)) {
			const newMilestonButton = {
				type: ELEMENT_TYPE.BUTTON,
				text: formatMessage({id: 'project_scoping.new-scope-group'}),
				callback: this.addPhase.bind(this),
				disabled: projectLocked,
				style: BUTTON_STYLE.OUTLINE,
				color: BUTTON_COLOR.PURPLE,
				userpilot: 'new-milestone-button',
				dataCy: 'new-ui-scoping-custom-button-container',
			};
			rightContent.push(newMilestonButton);
		}

		if (autoSchedulingEnabled && !parentGroup && !projectLocked) {
			const autoScheduleButton = {
				key: 'auto-schedule-button',
				type: ELEMENT_TYPE.BUTTON,
				customClassName: 'auto-scheduling-button',
				autoScheduleStyle: true,
				text: this.props.intl.formatMessage({id: 'auto_scheduling.auto_schedule'}),
				callback: this.onAutoScheduleButtonClicked.bind(this),
				style: BUTTON_STYLE.FILLED,
				color: BUTTON_COLOR.AI_BLUE,
			};
			rightContent.push(autoScheduleButton);
		}

		const collapse = {
			type: ELEMENT_TYPE.COLLAPSE,
			collapsed: !this.state.collapseAll,
			toggleCollapse: this.toggleCollapseAll.bind(this),
		};

		rightContent.push(collapse);

		if (!useThirdLevelNav) {
			const onboardingFlows = [
				{
					id: 'scoping-introduction',
					title: 'Scoping Intro',
					description: null,
					contentId: '1594304052lNpm0692',
				},
				{id: 'scoping-first-milestone', title: 'Scoping - Scoping out your first Milestone', description: null, contentId: '1594304249aHmt209'},
				{id: 'scoping-best-practices', title: 'Scoping - Tips and Tricks', description: null, contentId: '1594304278jNny2762'},
			];

			const onboardingComponent = {
				id: 'onboarding-component',
				intl: this.props.intl,
				type: ELEMENT_TYPE.ONBOARDING_POPUP,
				title: formatMessage({id: 'onboarding.scoping_onboarding_title'}),
				options: onboardingFlows,
			};
			rightContent.push(onboardingComponent);
		}

		const actionsMenu = {
			type: ELEMENT_TYPE.ACTIONS_MENU,
			options: [
				{
					key: 'GROUP_BY_PERSONS',
					text: formatMessage({id: 'common.group_by_person'}),
					hotkey: 'Shift + G',
					onClick: this.toggleGroupByPerson.bind(this),
					slider: true,
					checked: this.state.groupByPerson,
				},
				{
					key: 'SHOW_EMPTY_PERSONS',
					text: formatMessage({id: 'common.show_empty_persons'}),
					hotkey: 'Shift + E',
					onClick: this.toggleShowEmptyPersons.bind(this),
					locked: !this.state.groupByPerson,
					slider: true,
					checked: this.state.groupByPerson && this.state.showEmptyPersons,
				},
			],
			whiteInner: true,
			isWhite: true,
			blackIcon: true,
			userpilot: 'actions-menu-top',
			passedKeyDownHandler: this.handleShortcutProjectPhases.bind(this),
		};
		actionsMenu.options.push({
			key: 'GROUP_BY_ROLE',
			text: formatMessage({id: 'common.group_by_role'}),
			onClick: this.toggleGroupByRole.bind(this),
			slider: true,
			checked: this.state.groupByRole,
		});

		if ((hasSomePermission([PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION, PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE])) && this.props.viewer.project.budgetType === BUDGET_TYPE.RETAINER) {
			actionsMenu.options.push({
				key: 'SHOW_PERIODS',
				text: 'Show Periods',
				onClick: this.toggleShowPeriods.bind(this),
				slider: true,
				checked: this.state.showPeriods,
			});
			actionsMenu.options.push({
				key: 'SHOW_EMPTY_PERIODS',
				text: 'Show Empty Periods',
				onClick: this.toggleShowEmptyPeriods.bind(this),
				locked: !this.state.showPeriods,
				slider: true,
				checked: this.state.showPeriods && this.state.showEmptyPeriods,
			});
		}
		rightContent.push(actionsMenu);

		if (useThirdLevelNav) {
			return buildThirdLevelNavHeader(leftContent, rightContent, null, {innerRef: div => (this.header_bar = div)}, false);
		}

		return <HeaderBar innerRef={div => (this.header_bar = div)} parentGroup={parentGroup} leftContent={leftContent} rightContent={rightContent} />;
	}

	getTaskObjectFromId(id) {
		let task = null;
		this.tasks.forEach(t => {
			if (t.node.id === id) {
				task = t;
			}
		});
		return task;
	}

	getTaskAboveInList(placeholderId, sourceList, targetPerson) {
		if (placeholderId.includes('#')) {
			const destinationArr = placeholderId.split('#');
			placeholderId = destinationArr[1];
		}
		let taskId = placeholderId;
		let list = sourceList.sort(this.sortBySortOrder);
		if (this.state.groupByPerson) {
			if (targetPerson === 'UNASSIGNED' || targetPerson === null) {
				list = list.filter(task => task.assignedPersons.length === 0);
			} else {
				list = list.filter(task => task.assignedPersons.find(p => p.id === targetPerson));
			}
		} else if (this.state.groupByRole) {
			if (targetPerson === 'UNASSIGNED' || targetPerson === null) {
				list = list.filter(task => !task.role);
			} else {
				list = list.filter(task => task.role && task.role.id === targetPerson);
			}
		}
		let index = -1;
		if (placeholderId === 'END_OF_LIST') {
			index = list.length - 1;
		} else {
			index = list.findIndex(task => task.id === taskId) - 1;
		}

		if (index >= 0) {
			return list[index];
		} else return null;
	}

	getTasksForMilestone(milestoneId) {
		if (milestoneId === 'no-id') {
			return this.props.viewer.project.tasks.edges.filter(task => task.node.phase == null).map(t => t.node);
		} else {
			return this.phases.find(phase => phase.id === milestoneId).tasks;
		}
	}

	handleSelectMultipleTasks(ids) {
		const tasks = ids.map(id => {
			return this.getTaskObjectFromId(id);
		});
		const newSelectedTasks = this.state.selectedTasks;
		tasks.forEach(task => {
			const exist = this.state.selectedTasks.some(sTask => sTask.node.id === task.node.id);
			if (!exist) newSelectedTasks.push(task);
		});
		this.setState({selectedTasks: newSelectedTasks});
		this.updateSelectionMode(newSelectedTasks.length);
	}

	handleDeselectMultipleTasks(ids) {
		const newSelectedTasks = this.state.selectedTasks.filter(task => !ids.includes(task.node.id));
		this.setState({selectedTasks: newSelectedTasks});
		this.updateSelectionMode(newSelectedTasks.length);
	}

	registerRowSelection(rowId, shiftKey) {
		// disable shift select when grouping is active
		// because we sort the task in a way that does not supporl list select when grouped
		if (this.state.groupByPerson) {
			shiftKey = null;
		}
		this.handleRowSelected(rowId, shiftKey);
	}

	handleRowSelected(rowId, shiftKey) {
		let selectedTasks = [...this.state.selectedTasks];
		let taskId = rowId;
		let targetPerson;
		if (rowId.includes('#')) {
			const rowArr = rowId.split('#');
			targetPerson = rowArr[0];
			taskId = rowArr[1];
		}
		if (rowId.includes('-')) {
			const rowArr = rowId.split('-');
			targetPerson = rowArr[1];
			taskId = rowArr[0];
		}
		// Deep copy to avoid messing with previously selected tasks
		const taskToSelect = Object.assign({}, this.getTaskObjectFromId(taskId));
		const isEmptyPhase = taskToSelect.node.phase == null;
		let alreadySelected;
		if (this.state.groupByPerson) {
			alreadySelected = !!selectedTasks.find(elem => elem.node.id === taskId && elem.sourcePerson === targetPerson);
		} else {
			alreadySelected = !!selectedTasks.find(elem => elem.node.id === taskId);
		}
		// Always prioritize unselect if already selected
		if (alreadySelected) {
			// Remove selected element
			if (this.state.groupByPerson) {
				selectedTasks.splice(
					selectedTasks.findIndex(elem => elem.node.id === taskId && elem.sourcePerson === targetPerson),
					1
				);
			} else {
				selectedTasks.splice(
					selectedTasks.findIndex(elem => elem.node.id === taskId),
					1
				);
			}
		} else {
			// MultiSelect with groupByPerson
			if (this.state.groupByPerson && !isEmptyPhase) {
				if (shiftKey && this.state.selectedTasks.length > 0) {
					const personTasks = this.tasks
						.filter(
							task =>
								((task.node.phase && taskToSelect.node.phase && task.node.phase.id === taskToSelect.node.phase.id) || (!task.node.phase && !taskToSelect.node.phase)) &&
								(targetPerson === 'UNASSIGNED' ? task.node.assignedPersons.length === 0 : task.node.assignedPersons.find(p => p.id === targetPerson))
						)
						.sort(this.sortBySortOrder)
						.map(t => Object.assign({}, t)); // More deep copies :(
					let tasksToAdd = [];
					const start = selectedTasks[selectedTasks.length - 1];
					const end = taskToSelect;
					// Only multi-select within same person
					if (start && end && start.sourcePerson === targetPerson) {
						const startIndex = personTasks.findIndex(task => task.node.id === start.node.id) || 0;
						const endIndex = personTasks.findIndex(task => task.node.id === end.node.id);
						if (startIndex < endIndex) {
							// +1 to start to avoid adding the already added task
							tasksToAdd = personTasks.slice(startIndex, endIndex + 1);
						} else {
							// Slice always goes from 0..n, so flip direction of going from end to start
							tasksToAdd = personTasks.slice(endIndex, startIndex + 1);
						}
						// Avoid adding elements that were previously added
						tasksToAdd = tasksToAdd.filter(task => !selectedTasks.find(t => t.node.id === task.node.id && t.sourcePerson === targetPerson));
						tasksToAdd.forEach(t => (t.sourcePerson = targetPerson));
						selectedTasks = selectedTasks.concat(tasksToAdd);
					}
				}
				// Else add as normally
				else {
					taskToSelect.sourcePerson = targetPerson;
					selectedTasks.push(taskToSelect);
				}
			} else {
				// Do multi select on shift, if a previous task (starting point) was selected
				if (shiftKey && this.state.selectedTasks.length > 0) {
					const tasksFromMileStone = this.tasks.filter(task => (task.node.phase && taskToSelect.node.phase && task.node.phase.id === taskToSelect.node.phase.id) || (!task.node.phase && !taskToSelect.node.phase)).sort(this.sortBySortOrder);
					let tasksToAdd = [];
					const start = selectedTasks[selectedTasks.length - 1];
					const end = taskToSelect;
					if (start && end) {
						const startIndex = tasksFromMileStone.findIndex(task => task.node.id === start.node.id) || 0;
						const endIndex = tasksFromMileStone.findIndex(task => task.node.id === end.node.id);
						if (startIndex < endIndex) {
							// +1 to start to avoid adding the already added task
							tasksToAdd = tasksFromMileStone.slice(startIndex, endIndex + 1);
						} else {
							// Slice always goes from 0..n, so flip direction of going from end to start
							tasksToAdd = tasksFromMileStone.slice(endIndex, startIndex + 1);
						}
						// Avoid adding elements that were previously added
						tasksToAdd = tasksToAdd.filter(task => !selectedTasks.find(t => t.node.id === task.node.id));
						selectedTasks = selectedTasks.concat(tasksToAdd);
					}
				}
				// Else add as normally
				else selectedTasks.push(taskToSelect);
			}
		}

		if (selectedTasks.length > MAX_BULK_SELECTION) {
			createToast({
				duration: 5000,
				message: this.props.intl.formatMessage({id: 'common.max_bulk_selected'}, {tasks: MAX_BULK_SELECTION}),
			});
		}

		this.setState({
			selectedTasks: selectedTasks.length > MAX_BULK_SELECTION ? selectedTasks.slice(0, MAX_BULK_SELECTION) : selectedTasks,
		});

		this.updateSelectionMode(selectedTasks.length);
	}

	handleTaskDrag(draggable, destinationId, placeholderId) {
		let sourceTask;
		let sourcePerson;
		let targetPerson;
		let targetMilestone = destinationId;
		let draggableId = draggable.draggableId;

		if (destinationId && destinationId.includes('#')) {
			const destinationArr = destinationId.split('#');
			targetPerson = destinationArr[0] === 'UNASSIGNED' ? null : destinationArr[0];
			targetMilestone = destinationArr[1];
		}
		if (draggableId && draggableId.includes('#')) {
			const draggableArr = draggable.draggableId.split('#');
			sourcePerson = draggableArr[0] === 'UNASSIGNED' ? null : draggableArr[0];
			draggableId = draggableArr[1];
		}

		sourceTask = this.getTaskObjectFromId(draggableId);
		// Get task above placeholder
		const aboveTask = placeholderId ? this.getTaskAboveInList(placeholderId, this.getTasksForMilestone(targetMilestone), targetPerson) : undefined;
		if (sourceTask && targetMilestone) {
			let ids = [];
			const mutationObject = {};
			let tasksToMove = [];
			// If we have selected tasks, send these as well
			if (this.state.selectedTasks.length > 0) {
				tasksToMove = this.state.selectedTasks;
				// Purposefully sort before additional moved element may be added
				tasksToMove.sort(this.sortBySortOrder);
				// Was the moved task was not among the selected tasks?
				if (!tasksToMove.find(task => (task.sourcePerson ? task.sourcePerson === sourceTask.sourcePerson && task.node.id === sourceTask.node.id : task.node.id === sourceTask.node.id))) {
					// The extra dragged card goes in first, and ends up at the dragged position, everything else comes after in sort order
					tasksToMove.splice(0, 0, sourceTask);
				}
				ids = tasksToMove.map(task => task.node.id);
				if (this.state.groupByPerson) {
					// Since multiselect can select multiple different person-tasks, that are in fact the same tasks, we use this to make a distinct selection
					ids = [...new Set(ids)];
				}
			} else {
				ids = [sourceTask.node.id];
				// For optimistic response
			}
			mutationObject.existingAssignedPersons = sourceTask.node.assignedPersons.map(p => p.id);
			mutationObject.ids = ids;
			mutationObject.phaseId = targetMilestone === 'no-id' ? null : targetMilestone;
			if (aboveTask) {
				mutationObject.aboveTaskId = aboveTask.node ? aboveTask.node.id : aboveTask.id;
				mutationObject.optimisticTaskOrder = aboveTask.node ? aboveTask.node.sortOrder + 0.5 : aboveTask.sortOrder + 0.5;
			} else if (placeholderId) {
				// We only want to assume that null is top of list, if we actually have a placeholder at the top.
				mutationObject.aboveTaskId = null;
				mutationObject.optimisticTaskOrder = 0.5;
			}
			// Change assignments if new person
			if (sourcePerson !== targetPerson) {
				if (this.state.groupByRole) {
					mutationObject.roleId = targetPerson;
				} else {
					if (targetPerson != null) {
						// Person to add to all dragged tasks
						mutationObject.assignedPersonToAdd = targetPerson;
						// Person to remove from all dragged tasks
						if (sourcePerson != null) {
							const unassignPersonsFromTask = ids.map(id => {
								return {
									taskId: id,
									personIds: [sourcePerson],
								};
							});
							mutationObject.unassignPersonFromTask = unassignPersonsFromTask;
						}
					} else if (sourcePerson !== null) {
						let unassignPersonsFromTask;
						// If targetPerson is null, we want to unassign everyone
						if (tasksToMove.length > 1) {
							unassignPersonsFromTask = tasksToMove.map(task => {
								return {
									taskId: task.node.id,
									personIds: task.node.assignedPersons.map(p => p.id),
								};
							});
						} else {
							unassignPersonsFromTask = ids.map(id => {
								return {
									taskId: id,
									personIds: sourceTask.node.assignedPersons.map(p => p.id),
								};
							});
						}
						mutationObject.unassignPersonFromTask = unassignPersonsFromTask;
					}
				}
			}
			Util.CommitMutation(ReorderTaskMutation, mutationObject);
			// When grouping by person, tasks will become unselected when they change person, so we just clear to avoid getting halfway marked selections
			if (this.state.groupByPerson || this.state.groupByRole) {
				this.unselectTasks();
			}
		}
		this.setState({dragActive: false});
	}

	sortBySortOrder(a, b) {
		if (a.node && b.node) {
			if (a.node.sortOrder < b.node.sortOrder) return -1;
			if (a.node.sortOrder > b.node.sortOrder) return 1;
		} else {
			if (a.sortOrder < b.sortOrder) return -1;
			if (a.sortOrder > b.sortOrder) return 1;
		}

		return 0;
	}

	getContainerWidth() {
		// 66 margin around page, 26 padding on the table's sides
		const padding = 26;
		const margin = 66;

		const res = Math.max(document.documentElement.clientWidth, window.innerWidth) - 2 * margin - 2 * padding || 0;
		return res;
	}

	compareSprintDates = (a, b) => {
		let aStartDate = Moment({
			y: a.node.startYear,
			M: a.node.startMonth - 1,
			d: a.node.startDay,
		});
		let aEndDate = Moment({
			M: a.node.endMonth - 1,
			y: a.node.endYear,
			d: a.node.endDay,
		});
		let bStartDate = Moment({
			y: b.node.startYear,
			M: b.node.startMonth - 1,
			d: b.node.startDay,
		});
		let bEndDate = Moment({
			y: b.node.endYear,
			M: b.node.endMonth - 1,
			d: b.node.endDay,
		});
		//Date used for sorting sprints with not selected dates
		const dummyDate = Moment({
			y: -10000,
			M: 1,
			d: 1,
		});

		if (!aStartDate.isValid()) aStartDate = dummyDate.clone();
		if (!aEndDate.isValid()) aEndDate = dummyDate.clone();
		if (!bStartDate.isValid()) bStartDate = dummyDate.clone();
		if (!bEndDate.isValid()) bEndDate = dummyDate.clone();

		if (aStartDate.isBefore(bStartDate)) return 1;
		if (bStartDate.isBefore(aStartDate)) return -1;
		//If same date, sort by end date ascending
		if (aEndDate.isBefore(bEndDate)) return 1;
		if (bEndDate.isBefore(aEndDate)) return -1;

		const aId = parseInt(atob(a.node.id).replace('Sprint:', ''), 10);
		const bId = parseInt(atob(b.node.id).replace('Sprint:', ''), 10);
		if (aId < bId) return 1;
		return -1;
	};

	getTaskCellMaxWidth() {
		const w = this.getContainerWidth();
		// Calculate space for other cols only
		const ignoreCol = col => col.name === 'task-name' || col.name === 'task-id' || col.name === 'selector';
		// Space used by other headers than task name + id
		const usedSpace = this.state.availableColumns.reduce((acc, col) => ((col.checked || col.maintainSpace) && !ignoreCol(col) ? col.maxWidth + acc : acc), 0);
		if (usedSpace > w) {
			// base minwidth for overflow
			return 200;
		}
		return Math.max(200, w - usedSpace);
	}

	dataCSV() {
		let csvTasks = this.fixedPriceUtil ? this.tasks.map(task => ({...task.node, ...this.fixedPriceUtil.getTask(task.node.id)})) : this.tasks.map(task => task.node);
		csvTasks = csvTasks.sort((a, b) => {
			const aPhase = a.phase ? a.phase : null;
			const bPhase = b.phase ? b.phase : null;
			const samePhase = aPhase && bPhase && aPhase.id === bPhase.id;

			// Both are in same milestone, compare sort order
			if ((aPhase === null && bPhase === null) || samePhase) {
				return a.sortOrder - b.sortOrder;
			} else if (aPhase == null && bPhase) {
				return 1;
			} else if (aPhase && bPhase == null) {
				return -1;
			}
			// Else sort by milestone
			const aStartDate = aPhase.startYear ? Util.CreateMomentDate(aPhase.startYear, aPhase.startMonth, aPhase.startDay) : null;
			const bStartDate = bPhase.startYear ? Util.CreateMomentDate(bPhase.startYear, bPhase.startMonth, bPhase.startDay) : null;

			const sameDate = aStartDate && bStartDate && aStartDate.isSame(bStartDate);
			// Both milestones have the same start date, sort by milestone id
			if ((aStartDate == null && bStartDate == null) || sameDate) {
				return aPhase.id < bPhase.id ? 1 : -1;
			} else if (aStartDate == null && bStartDate) {
				return 1;
			} else if (aStartDate && bStartDate == null) {
				return -1;
			} else return aStartDate.isBefore(bStartDate) ? -1 : 1;
		});
		return csvTasks;
	}

	exportCSVNew() {
		const taskFormatter = new TaskFormatter(this.props.intl, ['phase-name'], ['chip-right', 'milestone', 'selector'], true);

		const project = this.props.viewer.project;
		const generalData = {projects: [project]};

		taskFormatter.exportData(this.state.availableColumns, this.dataCSV(), generalData, `${project.name}_scoping_data`, 'CSV');
	}

	exportCSV() {
		const {formatNumber} = this.props.intl;
		const dataPreFormatting = this.dataCSV();

		const data = [];
		const {formatDate} = this.props.intl;
		const isEstimatedInHours = this.props.viewer.project.estimationUnit === 'HOURS';
		const minsPerPoint = this.props.viewer.project.minutesPerEstimationPoint;

		const fixedPriceData = ProjectUtil.getFixedPriceData(this.props.viewer.project, this.props.viewer.availableFeatureFlags);

		const convertedEstimate = num => {
			return isEstimatedInHours ? num : formatNumber((num * minsPerPoint) / 60, {format: 'rounded_two_decimal'});
		};

		dataPreFormatting.forEach(t => {
			const d = {
				'milestone-name': t.phase ? '"' + t.phase.name + '"' : 'No milestone',
			};
			this.state.availableColumns
				.filter(c => c.checked && !['chip-right', 'milestone', 'selector'].includes(c.name))
				.forEach(c => {
					let val;
					const tr = t.timeRegistrations.edges.reduce((totalTime, tmpTimeReg) => totalTime + tmpTimeReg.node.minutesRegistered, 0);
					switch (c.name) {
						case 'task-id':
							val = 'T' + t.companyTaskId;
							break;
						case 'task-name':
							val = '"' + t.name + '"';
							break;
						case 'date':
							const dateString =
								(t.startDay
									? formatDate(Util.CreateNonUtcMomentDate(t.startYear, t.startMonth, t.startDay), {
											month: 'short',
											day: 'numeric',
									  })
									: '') +
								' - ' +
								(t.deadlineDay
									? formatDate(Util.CreateNonUtcMomentDate(t.deadlineYear, t.deadlineMonth, t.deadlineDay), {
											month: 'short',
											day: 'numeric',
									  })
									: '');
							val = dateString;
							break;
						case 'assigned-person':
							if (t.assignedPersons && t.assignedPersons.length > 0) {
								val = t.assignedPersons.map(a => a.firstName + (a.lastName !== '' ? ' ' + a.lastName : '')).toString();
							} else {
								val = '';
							}
							break;
						case 'assigned-role':
							if (t.role) {
								val = t.role.name;
							} else {
								val = '';
							}
							break;
						case 'done-percentage':
							val = t.progress ? t.progress + '%' : '0%';
							break;
						case 'low-estimate':
							val = t.estimateLow != null ? convertedEstimate(t.estimateLow) : '';
							break;
						case 'high-estimate':
							val = t.estimateHigh != null ? convertedEstimate(t.estimateHigh) : '';
							break;
						case 'forecast':
							val = t.estimateForecast != null ? convertedEstimate(t.estimateForecast) : '';
							break;
						case 'time-entries':
							val = tr ? tr : '0';
							break;
						case 'remaining':
							val = t.timeLeft !== null ? convertedEstimate(t.timeLeft) : '';
							break;
						case 'status':
							val = t.statusColumnV2.name;
							break;
						case 'over-high':
							val = t.estimateHigh !== null && tr !== null ? (isEstimatedInHours ? t.estimateHigh - tr : formatNumber((t.estimateHigh * minsPerPoint - tr) / 60, {format: 'rounded_two_decimal'})) : '';
							break;
						case 'over-forecast':
							val = t.estimateForecast !== null && tr != null ? (isEstimatedInHours ? t.estimateHigh - tr : formatNumber((t.estimateHigh * minsPerPoint - tr) / 60, {format: 'rounded_two_decimal'})) : '';
							break;
						case 'price':
							val = formatNumber(ProjectUtil.getEstimatedPrice(t, fixedPriceData), {format: 'always_two_decimal'});

							break;
						case 'actual-price':
							val = formatNumber(ProjectUtil.getActualPriceForTask(t, fixedPriceData), {format: 'always_two_decimal'});
							break;
						case 'sprint':
							val = t.sprint ? t.sprint.name : 'Backlog';
							break;
						case 'approved':
							val = t.approved ? 'Approved' : '';
							break;
						case 'labels':
							if (t.taskLabels && t.taskLabels.length > 0) {
								val = t.taskLabels.map(l => l.label.name).toString();
							} else {
								val = '';
							}
							break;
						default:
							break;
					}
					if (c.name.includes('forecast')) {
						if (c.name.includes('over')) {
							d[c.name.replace('over', 'difference').replace('forecast', 'estimate')] = val;
						} else {
							d[c.name.replace('forecast', 'estimate')] = val;
						}
					} else if (c.name.includes('price')) {
						d[c.name.replace('price', 'revenue')] = val;
					} else if (c.name.includes('over')) {
						d[c.name.replace('over', 'difference').replace('forecast', 'estimate')] = val;
					} else {
						d[c.name] = val;
					}
				});
			data.push(d);
		});

		const columnNames = ['milestone-name'];
		this.state.availableColumns
			.filter(c => c.checked && !['chip-right', 'milestone', 'selector'].includes(c.name))
			.forEach(c => {
				if (c.name.includes('forecast')) {
					if (c.name.includes('over')) {
						columnNames.push(c.name.replace('over', 'difference').replace('forecast', 'estimate'));
					} else {
						columnNames.push(c.name.replace('forecast', 'estimate'));
					}
				} else if (c.name.includes('price')) {
					columnNames.push(c.name.replace('price', 'revenue'));
				} else if (c.name.includes('over')) {
					columnNames.push(c.name.replace('over', 'difference').replace('forecast', 'estimate'));
				} else {
					columnNames.push(c.name);
				}
			});

		let exportData = columnNames + '\r\n';
		exportData += Util.JSONToCSV(data);
		const fileName = this.props.viewer.project.name.replace(' ', '_').toLowerCase() + '_scoping_data.csv';
		Util.exportToCSV(exportData, fileName);
	}

	handleDragStart(draggable) {
		this.draggedOrigin = draggable.droppableId;
		this.setState({dragActive: true});
	}

	toggleProjectTotalExpanded() {
		this.setState(prevState => {
			return {projectTotalExpanded: !prevState.projectTotalExpanded};
		});
	}

	getTimeRegsForPeriod(period) {
		const inHours = period.periodBudgetType !== PERIOD_BUDGET_TYPE.FIXED_PRICE;
		const projectTimeRegs = this.props.viewer.project.timeRegistrations ? this.props.viewer.project.timeRegistrations.edges.filter(tReg => !tReg.node.task) : [];
		const taskTimeRegs = this.props.viewer.project.tasks.edges.filter(task => inHours || task.node.billable).reduce((acc, task) => acc.concat(task.node.timeRegistrations ? task.node.timeRegistrations.edges : []), []);
		const allTimeRegs = projectTimeRegs.concat(taskTimeRegs);

		const startDate = Util.CreateMomentDate(period.startYear, period.startMonth, period.startDay);
		const endDate = Util.CreateMomentDate(period.endYear, period.endMonth, period.endDay);
		const timeRegWithinDate = timeReg => {
			const tDate = Util.CreateMomentDate(timeReg.node.year, timeReg.node.month, timeReg.node.day);
			return tDate && tDate.isBetween(startDate, endDate, 'days', []);
		};
		return allTimeRegs.filter(timeReg => timeRegWithinDate(timeReg) && !timeRegIsInConflict(timeReg.node, period));
	}

	isTaskTimeRegistrationsLoaded(viewer) {
		return !!viewer.project.timeRegistrations;
	}

	render() {
		const {formatMessage, formatNumber} = this.props.intl;
		const projectLocked = this.props.viewer.project.status === 'DONE' || this.props.viewer.project.status === 'HALTED';
		const updateMilestoneAccess = hasPermission(PERMISSION_TYPE.MILESTONE_UPDATE);
		const hasFinancialAccess = hasSomePermission([PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION, PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE]);
		const useThirdLevelNav = hasFeatureFlag('third_level_nav', this.props.viewer.availableFeatureFlags);
		const currencySymbol = Util.GetCurrencySymbol(this.props.viewer.project.rateCard ? this.props.viewer.project.rateCard.currency : this.props.viewer.company.currency);
		const placeUnitBeforeValue = Util.CurrencyIsPrefixed(currencySymbol);
		const {project} = this.props.viewer;
		const hasRateCard = project.rateCard !== null;
		this.tasks = cloneDeep(project.tasks.edges).sort(this.sortBySortOrder);
		const isEstimatedInHours = project.estimationUnit === 'HOURS';
		const isEstimatedInNewPoints = !isEstimatedInHours;
		const locale = Util.GetLocaleFromPersonLanguage(this.props.viewer.language);

		if (this.state.filterFunctions && this.state.filterFunctions.taskFilter) {
			const options = {teams: this.props.viewer.company.teams.edges};
			this.tasks = this.tasks.filter(task => this.state.filterFunctions.taskFilter(task.node, options));
		}

		if (this.state.searchFilterValue.length > 0) {
			const searchFilter = task => {
				const taskValue = 'T' + task.node.companyTaskId + task.node.name;
				const searchValue = this.state.searchFilterValue.trim();
				return Util.normalizedIncludes(taskValue, searchValue);
			};
			this.tasks = this.tasks.filter(searchFilter);
		}

		const phaseIDs = this.state.phaseFilterValue.map(e => e.value);
		let phases = [];
		const dateInPast = (y, m, d) => {
			const today = Moment();
			const dateAsMoment = Util.CreateMomentDate(y, m, d);
			return dateAsMoment && today.isAfter(dateAsMoment);
		};

		const fixedPriceDataProjectMap = new Map(); // Stored in Map to align with sprints
		const fixedPriceData = ProjectUtil.getFixedPriceData(this.props.viewer.project, this.props.viewer.availableFeatureFlags);
		fixedPriceDataProjectMap.set(this.props.viewer.project.id, fixedPriceData);

		phases = cloneDeep(this.props.viewer.project.phases.edges)
			.sort((a, b) => this.state.phasesOrderMap.get(a.node.id) - this.state.phasesOrderMap.get(b.node.id))
			.map(phase => {
				const group_phase = phase.node;
				group_phase.tasks = this.tasks.filter(task => task.node.phase && task.node.phase.id === group_phase.id).map(task => task.node);
				group_phase.allTasks = project.tasks.edges.filter(task => task.node.phase && task.node.phase.id === group_phase.id).map(task => task.node);
				group_phase.tasks = group_phase.tasks.sort((a, b) => a.sortOrder - b.sortOrder);

				// Phase is done if we can find no tasks where the task isn't done
				group_phase.isDone =
					group_phase.tasks.length > 0 ? group_phase.tasks.filter(task => task.statusColumnV2.category !== WorkflowCategories.DONE).length === 0 : dateInPast(group_phase.deadlineYear, group_phase.deadlineMonth, group_phase.deadlineDay);

				//phase totals
				let lowUnfiltered = 0;
				let highUnfiltered = 0;
				let forecastUnfiltered = 0;
				let priceUnfiltered = 0;
				let currentPriceUnfiltered = 0;
				let timeEntriesUnfiltered = 0;
				let totalRemaining = 0;
				group_phase.allTasks.forEach(tmpTask => {
					const taskForecast = tmpTask.estimateForecast != null ? tmpTask.estimateForecast : 0;
					lowUnfiltered += tmpTask.estimateLow != null ? tmpTask.estimateLow : 0;
					highUnfiltered += tmpTask.estimateHigh != null ? tmpTask.estimateHigh : 0;
					forecastUnfiltered += taskForecast;
					priceUnfiltered += ProjectUtil.getEstimatedPrice(tmpTask, fixedPriceData);
					currentPriceUnfiltered += ProjectUtil.getActualPriceForTask(tmpTask, fixedPriceData);
					timeEntriesUnfiltered += tmpTask.timeRegistrations ? tmpTask.timeRegistrations.edges.reduce((totalTime, tmpTimeReg) => totalTime + tmpTimeReg.node.minutesRegistered, 0) : 0;
				});
				group_phase.lowUnfiltered = lowUnfiltered;
				group_phase.highUnfiltered = highUnfiltered;
				group_phase.forecastUnfiltered = forecastUnfiltered;
				group_phase.priceUnfiltered = priceUnfiltered;
				group_phase.currentPriceUnfiltered = currentPriceUnfiltered;
				group_phase.timeEntriesUnfiltered = timeEntriesUnfiltered;
				group_phase.totalRemaining = totalRemaining;
				//phase done calculation
				const calcTasks = group_phase.allTasks.filter(task => {
					return task.approved;
				});

				const approvedPhaseForecast = calcTasks.reduce((total, tmpTask) => total + tmpTask.estimateForecast, 0);
				const approvedPhaseDoneForecast = calcTasks.filter(task => task.statusColumnV2.category === WorkflowCategories.DONE).reduce((total, tmpTask) => total + tmpTask.estimateForecast, 0);
				const approvedPhaseRemaining = calcTasks.reduce((total, tmpTask) => total + tmpTask.timeLeft, 0);
				const numberOfDoneTasks = calcTasks.filter(task => task.statusColumnV2.category === WorkflowCategories.DONE).length;

				group_phase.doneApprovedTaskCount = numberOfDoneTasks;
				group_phase.totalApprovedTaskCount = calcTasks.length;

				group_phase.hide = (phaseIDs.length > 0 && !phaseIDs.includes(phase.node.id)) || (this.state.searchFilterValue.length > 0 && group_phase.tasks.length === 0);

				group_phase.low = calcTasks.reduce((total, tmpTask) => total + (tmpTask.estimateLow != null ? tmpTask.estimateLow : 0), 0);
				group_phase.high = calcTasks.reduce((total, tmpTask) => total + (tmpTask.estimateHigh != null ? tmpTask.estimateHigh : 0), 0);
				group_phase.forecast = calcTasks.reduce((total, tmpTask) => total + (tmpTask.estimateForecast != null ? tmpTask.estimateForecast : 0), 0);
				group_phase.doneForecast = approvedPhaseDoneForecast;
				group_phase.price = calcTasks.reduce((total, tmpTask) => {
					if (this.fixedPriceUtil) {
						return total + this.fixedPriceUtil.getTaskPlannedRevenue(tmpTask.id);
					}
					return total + ProjectUtil.getEstimatedPrice(tmpTask, fixedPriceData);
				}, 0);
				group_phase.currentPrice = calcTasks.reduce((total, tmpTask) => {
					if (this.fixedPriceUtil) {
						return total + this.fixedPriceUtil.getTaskActualRevenue(tmpTask.id);
					}
					return total + ProjectUtil.getActualPriceForTask(tmpTask, fixedPriceData);
				}, 0);
				group_phase.timeEntries = calcTasks.reduce((total, tmpTask) => total + (tmpTask.timeRegistrations ? tmpTask.timeRegistrations.edges.reduce((totalTime, tmpTimeReg) => totalTime + tmpTimeReg.node.minutesRegistered, 0) : 0), 0);
				group_phase.reportedNotDone = calcTasks
					.filter(task => task.statusColumnV2.category !== WorkflowCategories.DONE)
					.reduce((total, tmpTask) => total + (tmpTask.timeRegistrations ? tmpTask.timeRegistrations.edges.reduce((totalTime, tmpTimeReg) => totalTime + tmpTimeReg.node.minutesRegistered, 0) : 0), 0);
				if (!isEstimatedInHours) {
					group_phase.reportedNotDone /= this.props.viewer.project.minutesPerEstimationPoint;
				}
				group_phase.totalRemaining = group_phase.tasks.reduce((total, tmpTask) => total + (tmpTask.timeLeft != null ? tmpTask.timeLeft : 0), 0);
				group_phase.approvedRemaining = calcTasks.reduce((total, tmpTask) => total + (tmpTask.timeLeft != null ? tmpTask.timeLeft : 0), 0);
				group_phase.totalHighDiff = isEstimatedInHours ? group_phase.high - group_phase.timeEntries : group_phase.high * this.props.viewer.project.minutesPerEstimationPoint - group_phase.timeEntries;
				group_phase.totalForecastDiff = isEstimatedInHours ? group_phase.forecast - group_phase.timeEntries : group_phase.forecast * this.props.viewer.project.minutesPerEstimationPoint - group_phase.timeEntries;
				if (this.props.viewer.availableFeatureFlags.find(flag => flag.key === 'use_new_progress_calc')) {
					group_phase.progress = Math.round(Util.calculateTaskGroupCompletion(approvedPhaseDoneForecast, group_phase.reportedNotDone, approvedPhaseRemaining, group_phase.doneApprovedTaskCount, group_phase.totalApprovedTaskCount) * 100);
				} else {
					group_phase.progress = Util.deprecated_calculateElementProgress(
						approvedPhaseForecast,
						calcTasks.reduce((total, tmpTask) => total + (tmpTask.timeRegistrations ? tmpTask.timeRegistrations.edges.reduce((totalTime, tmpTimeReg) => totalTime + tmpTimeReg.node.minutesRegistered, 0) : 0), 0),
						approvedPhaseRemaining,
						calcTasks.length,
						numberOfDoneTasks,
						isEstimatedInHours,
						this.props.viewer.project.minutesPerEstimationPoint
					);
				}
				return group_phase;
			});
		this.phases = phases;

		const empty_phase = {
			id: null,
		};
		empty_phase.tasks = this.tasks
			.filter(task => {
				return task.node.phase === null;
			})
			.map(task => task.node);
		empty_phase.calcTasks = project.tasks.edges
			.filter(task => {
				return task.node.phase === null && task.node.approved === true;
			})
			.map(task => task.node);
		empty_phase.allTasks = project.tasks.edges
			.filter(task => {
				return task.node.phase === null;
			})
			.map(task => task.node);
		//empty phase totals
		empty_phase.tasks = empty_phase.tasks.sort((a, b) => a.sortOrder - b.sortOrder);
		empty_phase.low = empty_phase.calcTasks.reduce((total, tmpTask) => total + (tmpTask.estimateLow != null ? tmpTask.estimateLow : 0), 0);
		empty_phase.high = empty_phase.calcTasks.reduce((total, tmpTask) => total + (tmpTask.estimateHigh != null ? tmpTask.estimateHigh : 0), 0);
		empty_phase.lowUnfiltered = empty_phase.allTasks.reduce((total, tmpTask) => total + (tmpTask.estimateLow != null ? tmpTask.estimateLow : 0), 0);
		empty_phase.highUnfiltered = empty_phase.allTasks.reduce((total, tmpTask) => total + (tmpTask.estimateHigh != null ? tmpTask.estimateHigh : 0), 0);
		empty_phase.forecastUnfiltered = empty_phase.allTasks.reduce((total, tmpTask) => total + (tmpTask.estimateForecast != null ? tmpTask.estimateForecast : 0), 0);
		empty_phase.priceUnfiltered = empty_phase.allTasks.reduce((total, tmpTask) => total + (tmpTask.estimateForecastPrice != null ? tmpTask.estimateForecastPrice : 0), 0);
		empty_phase.currentPriceUnfiltered = empty_phase.allTasks.reduce((total, tmpTask) => total + (tmpTask.currentPrice != null ? tmpTask.currentPrice : 0), 0);
		empty_phase.timeEntriesUnfiltered = empty_phase.allTasks.reduce(
			(total, tmpTask) => total + (tmpTask.timeRegistrations ? tmpTask.timeRegistrations.edges.reduce((totalTime, tmpTimeReg) => totalTime + tmpTimeReg.node.minutesRegistered, 0) : 0),
			0
		);
		empty_phase.timeEntries = empty_phase.calcTasks.reduce((total, tmpTask) => total + (tmpTask.timeRegistrations ? tmpTask.timeRegistrations.edges.reduce((totalTime, tmpTimeReg) => totalTime + tmpTimeReg.node.minutesRegistered, 0) : 0), 0);
		empty_phase.approvedRemaining = empty_phase.calcTasks.reduce((total, tmpTask) => total + (tmpTask.timeLeft != null ? tmpTask.timeLeft : 0), 0);
		empty_phase.forecast = empty_phase.calcTasks.reduce((total, tmpTask) => total + (tmpTask.estimateForecast != null ? tmpTask.estimateForecast : 0), 0);
		empty_phase.totalHighDiff = isEstimatedInHours ? empty_phase.high - empty_phase.timeEntries : empty_phase.high * this.props.viewer.project.minutesPerEstimationPoint - empty_phase.timeEntries;
		empty_phase.totalForecastDiff = isEstimatedInHours ? empty_phase.forecast - empty_phase.timeEntries : empty_phase.forecast * this.props.viewer.project.minutesPerEstimationPoint - empty_phase.timeEntries;
		empty_phase.price = empty_phase.calcTasks.reduce((total, tmpTask) => total + ProjectUtil.getEstimatedPrice(tmpTask, fixedPriceData), 0);
		empty_phase.currentPrice = empty_phase.calcTasks.reduce((total, tmpTask) => total + ProjectUtil.getActualPriceForTask(tmpTask, fixedPriceData), 0);
		//empty phase done calc
		const emptyPhaseCalcTasks = empty_phase.allTasks.filter(task => {
			return task.approved;
		});
		const emptyApprovedForecast = emptyPhaseCalcTasks.reduce((total, tmpTask) => total + tmpTask.estimateForecast, 0);
		const emptyApprovedDoneForecast = emptyPhaseCalcTasks.filter(task => task.statusColumnV2 && task.statusColumnV2.category === WorkflowCategories.DONE).reduce((total, tmpTask) => total + tmpTask.estimateForecast, 0);
		const emptyRemaining = emptyPhaseCalcTasks.reduce((total, tmpTask) => total + tmpTask.timeLeft, 0);
		const emptyNumberOfDoneTasks = emptyPhaseCalcTasks.filter(task => task.statusColumnV2 && task.statusColumnV2.category === WorkflowCategories.DONE).length;
		empty_phase.reportedNotDone = emptyPhaseCalcTasks
			.filter(task => task.statusColumnV2 && task.statusColumnV2.category !== WorkflowCategories.DONE)
			.reduce((total, tmpTask) => total + (tmpTask.timeRegistrations != null ? tmpTask.timeRegistrations.edges.reduce((totalTime, tmpTimeReg) => totalTime + tmpTimeReg.node.minutesRegistered, 0) : 0), 0);
		if (!isEstimatedInHours) {
			empty_phase.reportedNotDone /= this.props.viewer.project.minutesPerEstimationPoint;
		}
		empty_phase.doneForecast = emptyPhaseCalcTasks.filter(task => task.statusColumnV2.category === WorkflowCategories.DONE).reduce((total, tmpTask) => total + (tmpTask.estimateForecast != null ? tmpTask.estimateForecast : 0), 0);
		empty_phase.doneApprovedTaskCount = emptyNumberOfDoneTasks;
		empty_phase.totalApprovedTaskCount = emptyPhaseCalcTasks.length;

		if (this.props.viewer.availableFeatureFlags.find(flag => flag.key === 'use_new_progress_calc')) {
			empty_phase.progress = Math.round(Util.calculateTaskGroupCompletion(emptyApprovedDoneForecast, empty_phase.reportedNotDone, emptyRemaining, empty_phase.doneApprovedTaskCount, empty_phase.totalApprovedTaskCount) * 100);
		} else {
			empty_phase.progress = Util.deprecated_calculateElementProgress(
				emptyApprovedForecast,
				emptyPhaseCalcTasks.reduce((total, tmpTask) => total + (tmpTask.timeRegistrations != null ? tmpTask.timeRegistrations.edges.reduce((totalTime, tmpTimeReg) => totalTime + tmpTimeReg.node.minutesRegistered, 0) : 0), 0),
				emptyRemaining,
				emptyPhaseCalcTasks.length,
				emptyNumberOfDoneTasks,
				isEstimatedInHours,
				this.props.viewer.project.minutesPerEstimationPoint
			);
		}

		empty_phase.hide = (phaseIDs.length > 0 && !phaseIDs.includes(null)) || (this.state.searchFilterValue.length > 0 && empty_phase.tasks.length === 0);

		const projectPersons = this.props.viewer.project.projectPersons.edges;

		// Project totals for timeregs on project
		let projectTimeRegistrations;
		let projectRegistered;
		let projectTimePrice;
		if (project.timeRegistrations) {
			projectTimeRegistrations = project.timeRegistrations.edges.filter(tReg => tReg.node.task == null);
			projectRegistered = projectTimeRegistrations.reduce((totalTime, tmpTimeReg) => totalTime + tmpTimeReg.node.minutesRegistered, 0);
			projectTimePrice = fixedPriceData.newFixedPrice ? 0 : projectTimeRegistrations.reduce((totalPrice, tmpTimeReg) => totalPrice + tmpTimeReg.node.price, 0);
		}
		const low_total = phases.reduce((total, phase) => total + phase.low, 0) + empty_phase.low;
		const high_total = phases.reduce((total, phase) => total + phase.high, 0) + empty_phase.high;
		const forecast_total = phases.reduce((total, phase) => total + phase.forecast, 0) + empty_phase.forecast;
		const done_forecast_total = phases.reduce((total, phase) => total + phase.doneForecast, 0) + empty_phase.doneForecast;
		let price_total;
		let currentPrice_total;
		if (this.fixedPriceUtil) {
			price_total = this.fixedPriceUtil.getFixedPrice();
			currentPrice_total = this.fixedPriceUtil.getTotalCalculatedActualRevenue();
		} else {
			price_total = phases.reduce((total, phase) => total + phase.price, 0) + empty_phase.price;
			currentPrice_total = phases.reduce((total, phase) => total + phase.currentPrice, 0) + empty_phase.currentPrice + projectTimePrice;
		}
		const time_total = phases.reduce((total, phase) => total + phase.timeEntries, 0) + empty_phase.timeEntries + projectRegistered;
		const reported_not_done_total = phases.reduce((total, phase) => total + phase.reportedNotDone, 0) + empty_phase.reportedNotDone;
		const remaining_approved_total = phases.reduce((total, phase) => total + phase.approvedRemaining, 0) + empty_phase.approvedRemaining;

		const timesLeft = phases.concat(empty_phase).map(phase => phase.allTasks.map(task => task.timeLeft));
		const flattened = timesLeft.reduce((total, elem) => total.concat(elem), []);
		const sum = flattened.reduce((total, elem) => total + elem, 0);
		const remaining_total = sum;

		const isEmpty = this.props.viewer.project.tasks.edges.length === 0 && this.props.viewer.project.phases.edges.length === 0;
		const anySelectFiltersUsed =
			this.state.phaseFilterValue.length ||
			this.state.recentlyUpdatedFilterValue.length ||
			this.state.teamFilterValue.length ||
			this.state.teammemberFilterValue.length ||
			this.state.statusFilterValue.length ||
			this.state.labelFilterValue.length ||
			this.state.sprintFilterValue.length ||
			this.state.roleFilterValue.length ||
			this.state.blocked_bugFilterValue.length;
		const searchUsed = this.state.searchFilterValue.length;

		let donePercentage;
		if (this.props.viewer.availableFeatureFlags.find(flag => flag.key === 'use_new_progress_calc')) {
			const doneApprovedTaskCount = phases.concat(empty_phase).reduce((total, phase) => total + phase.doneApprovedTaskCount, 0);
			const totalApprovedTaskCount = phases.concat(empty_phase).reduce((total, phase) => total + phase.totalApprovedTaskCount, 0);

			donePercentage = Math.round(Util.calculateTaskGroupCompletion(done_forecast_total, reported_not_done_total, remaining_approved_total, doneApprovedTaskCount, totalApprovedTaskCount) * 100);
		} else {
			donePercentage = Util.deprecated_calculateElementProgress(
				forecast_total,
				time_total,
				remaining_total,
				this.props.viewer.project.tasks.edges.length,
				this.props.viewer.project.tasks.edges.filter(task => task.node.statusColumnV2 && task.node.statusColumnV2.category === WorkflowCategories.DONE).length,
				isEstimatedInHours,
				this.props.viewer.project.minutesPerEstimationPoint
			); //project.completion;
		}

		const done = formatMessage({id: 'common.x_percentage'}, {percentage: isNaN(donePercentage) ? 0 : donePercentage});

		let low;
		let high;
		let forecast;
		let remaining;
		let overHigh;
		let overForecast;
		if (isEstimatedInHours) {
			low = Util.convertMinutesToFullHour(low_total, this.props.intl);
			high = Util.convertMinutesToFullHour(high_total, this.props.intl);
			forecast = Util.convertMinutesToFullHour(forecast_total, this.props.intl);
			remaining = Util.convertMinutesToFullHour(remaining_approved_total, this.props.intl);
			overHigh = Util.convertMinutesToFullHour(high_total - time_total, this.props.intl);
			overForecast = Util.convertMinutesToFullHour(forecast_total - time_total, this.props.intl);
		} else {
			low = formatMessage({id: 'common.x_points'}, {points: low_total});
			high = formatMessage({id: 'common.x_points'}, {points: high_total});
			forecast = formatMessage({id: 'common.x_points'}, {points: forecast_total});
			remaining = formatMessage({id: 'common.x_points'}, {points: remaining_approved_total});
			overHigh = Util.convertMinutesToFullHour(high_total * this.props.viewer.project.minutesPerEstimationPoint - time_total, this.props.intl);
			overForecast = Util.convertMinutesToFullHour(forecast_total * this.props.viewer.project.minutesPerEstimationPoint - time_total, this.props.intl);
		}

		const timeEntries = Util.convertMinutesToFullHour(time_total, this.props.intl);
		const projectTimeRegistered = projectRegistered > 0 ? {label: null, value: Util.convertMinutesToFullHour(projectRegistered, this.props.intl), cy: 'total-time'} : null;

		const price = placeUnitBeforeValue
			? currencySymbol + formatNumber(Math.round(price_total * 100.0) / 100.0, {format: 'always_two_decimal'})
			: formatNumber(Math.round(price_total * 100.0) / 100.0, {format: 'always_two_decimal'}) + currencySymbol;
		const actualPrice = placeUnitBeforeValue
			? currencySymbol + formatNumber(Math.round(currentPrice_total * 100.0) / 100.0, {format: 'always_two_decimal'})
			: formatNumber(Math.round(currentPrice_total * 100.0) / 100.0, {format: 'always_two_decimal'}) + currencySymbol;

		const projectReportedTimePrice =
			projectTimePrice > 0 ? (placeUnitBeforeValue ? currencySymbol + formatNumber(projectTimePrice, {format: 'always_two_decimal'}) : formatNumber(projectTimePrice, {format: 'always_two_decimal'}) + currencySymbol) : '';

		const filters = this.fillOldFilterOptions();

		const moveMilestoneDisabled = this.props.viewer.project.vstsProject || this.props.viewer.project.jiraCloudProject || this.props.viewer.project.jiraServerProject;

		const activeFiltersCount = filters.filter(filter => {
			return filter.value.length > 0;
		}).length;

		switch (this.state.selectedTab.value) {
			case 'done':
				phases = phases.filter(phase => phase.isDone);
				break;
			case 'active':
				phases = phases.filter(phase => !phase.isDone);
				break;
			case 'all':
			default:
				break;
		}

		const isBaselineProject = Util.isBaselineProject(this.props.viewer.company.modules, this.props.viewer.project);

		const emptyPhaseHeader = (
			<PhasesPhaseHeader
				lazyDataFetched={this.state.lazyDataFetched}
				cy={'milestone-header'}
				projectLocked={projectLocked}
				phase={empty_phase}
				phaseIndex={'empty'}
				project={project}
				emptyPhase={true}
				isEstimatedInHours={isEstimatedInHours}
				hasRateCard={hasRateCard}
				currencySymbol={currencySymbol}
				placeUnitBeforeValue={placeUnitBeforeValue}
				hasFinancialAccess={hasFinancialAccess}
				//showPrice={this.state.showPrice}
				//showCurrentPrice={this.state.showCurrentPrice}
				availableColumns={this.state.availableColumns}
				onExpansionChange={this.togglePhaseExpanded.bind(this)}
				expanded={this.getIsPhaseExpanded(empty_phase.id)}
				viewer={this.props.viewer}
				isNewMilestone={this.state.focusPhaseId === empty_phase.id}
				scrollToNewMilestone={this.scrollToNewMilestone}
				retry={this.refetch}
				taskCellMaxWidth={this.state.taskCellMaxWidth}
				moveMilestoneDisabled={!!moveMilestoneDisabled}
				isBaselineProject={isBaselineProject}
			/>
		);
		const totalTableMinWidth = this.state.availableColumns.find(elem => elem.name === 'approved').checked ? this.state.tableMinWidth + 132 : this.state.tableMinWidth + 222;
		const roles = this.props.viewer.company.roles.edges;

		const sortedSprints = project.sprintTimeBox
			? cloneDeep(project.sprints.edges)
					.sort(this.compareSprintDates)
					.map(sprint => ({value: sprint.node.id, label: sprint.node.name}))
			: null;

		const retainerPeriods = project.retainerPeriods.edges;
		const phasesOutsidePeriods = phases.filter(phase => {
			const periodsForMilestone = Util.getPeriodForMilestone(phase, retainerPeriods);
			return !periodsForMilestone || periodsForMilestone.length === 0;
		});

		const taskCount = this.state.selectedTasks.length;

		return (
			<div className={'project-phases-v2' + (!projectLocked ? ' active' : '') + (isEmpty ? ' empty' : '')} ref={div => (this._phases_page = div)} data-cy={'deprecated-scoping-page'}>
				{taskCount > 0 && 
					<BulkSelectPopup
						itemCount={taskCount}
						counterText={this.props.intl.formatMessage({ id: 'bulk_edit.tasks_selected' })}
						actionOptions={this.getBulkUpdateOptions()}
						onClose={() => this.unselectTasks()}
						complexOptions={getComplexBulkOptions(
							this.showAutomateModal.bind(this), 
							null,
							this.props.intl
						)}
					/>
				}
				{this.props.children}
				{useThirdLevelNav ? this.getHeaderTitle() : null}
				{this.constructHeaderBar()}
				{this.tasks.length === 0 && (searchUsed || anySelectFiltersUsed) && !isEmpty ? (
					<InsightsEmptyState infoMessageId={searchUsed && !anySelectFiltersUsed ? 'scheduling.no-match' : 'scheduling.no-match-generic'} searchText={this.state.searchFilterValue} />
				) : isEmpty ? (
					<EmptyState pageName={EMPTY_STATE.SCOPING}></EmptyState>
				) : project.budgetType === BUDGET_TYPE.RETAINER && retainerPeriods.length > 0 && this.state.showPeriods ? (
					/* Retainer Project Scoping start */
					<div ref={div => (this.section_body = div)} className={'section-body flow-sample-scoping-milestone'}>
						<DragDropContext
							ref={div => (this.dnd_context = div)}
							scrollYSpeed={25}
							scrollContainerHeight={this.state.contextHeight || window.innerHeight}
							scrollContainerMinHeight={this.state.contextHeight || window.innerHeight}
							dragAndDropGroup={this.state.dragAndDropGroup}
							onDragEnd={this.handleTaskDrag.bind(this)}
							onDragStart={this.handleDragStart.bind(this)}
							outerScrollBar={true}
						>
							<ProjectTotalHeader
								lazyDataFetched={this.state.lazyDataFetched}
								done={done}
								low={low}
								high={high}
								forecast={forecast}
								remaining={remaining}
								price={price}
								actualPrice={actualPrice}
								timeEntries={timeEntries}
								overHigh={overHigh}
								hasScroll={this.state.hasScroll}
								overForecast={overForecast}
								tableMinWidth={totalTableMinWidth}
								projectTotalExpanded={this.state.projectTotalExpanded}
								toggleProjectTotalExpanded={this.toggleProjectTotalExpanded.bind(this)}
								availableColumns={this.state.availableColumns}
								taskCellMaxWidth={this.state.taskCellMaxWidth}
								projectTimeRegistered={projectTimeRegistered}
								projectReportedTimePrice={projectReportedTimePrice}
							/>
							{retainerPeriods.map((period, pIndex) => {
								const periodPhases = Util.getMilestonesForPeriod(period.node, phases);
								const timeRegsForPeriod = this.getTimeRegsForPeriod(period.node);
								if (periodPhases.length > 0 || this.state.showEmptyPeriods) {
									return (
										<>
											<PhasesPeriodHeader
												intl={this.props.intl}
												currencySymbol={currencySymbol}
												period={period.node}
												timeRegsForPeriod={timeRegsForPeriod}
												phases={periodPhases}
												projectColor={project.projectColor}
												taskCellMaxWidth={this.state.taskCellMaxWidth}
												minWidth={totalTableMinWidth}
												isEstimatedInHours={isEstimatedInHours}
												isEstimatedInNewPoints={isEstimatedInNewPoints}
											/>
											{periodPhases.map((phase, index) => {
												const phaseHeader = (
													<PhasesPhaseHeader
														lazyDataFetched={this.state.lazyDataFetched}
														cy={'milestone-header'}
														disabled={projectLocked || !updateMilestoneAccess}
														phaseIndex={index}
														phase={phase}
														project={project}
														company={this.props.viewer.company}
														emptyPhase={false}
														isEstimatedInHours={isEstimatedInHours}
														hasRateCard={hasRateCard}
														currencySymbol={currencySymbol}
														placeUnitBeforeValue={placeUnitBeforeValue}
														hasFinancialAccess={hasFinancialAccess}
														availableColumns={this.state.availableColumns}
														onExpansionChange={this.togglePhaseExpanded.bind(this)}
														expanded={this.getIsPhaseExpanded(phase.id)}
														isNewMilestone={this.state.focusPhaseId === phase.id}
														scrollToNewMilestone={this.scrollToNewMilestone}
														// showMilestoneLocationModal={this.props.route.showMilestoneLocationModal}
														retry={this.refetch}
														viewer={this.props.viewer}
														taskCellMaxWidth={this.state.taskCellMaxWidth}
														moveMilestoneDisabled={!!moveMilestoneDisabled}
														isBaselineProject={isBaselineProject}
													/>
												);
												//let minWidth = this.state.availableColumns.find(elem => elem.name === 'approved').checked ? this.state.tableMinWidth : this.state.tableMinWidth + 92;
												return (
													<div
														key={phase.id}
														id={'phase-wrapper-' + phase.id}
														data-cy="new-ui-scoping-phase-wrapper"
														className={'phase-wrapper' + (phase.hide || (phase.tasks.length === 0 && activeFiltersCount > 0) ? ' no-margin' : '')}
														style={{
															minWidth: totalTableMinWidth,
														}}
													>
														{phase.hide || (phase.tasks.length === 0 && activeFiltersCount > 0) ? null : (
															<VisibilitySensor scrollCheck={true} partialVisibility offset={{top: -100, bottom: -300}}>
																{({isVisible}) => {
																	const isCollapsed = !this.getIsPhaseExpanded(phase.id);
																	return (
																		<PhasesPhase
																			timeRegistrationsLoaded={this.isTaskTimeRegistrationsLoaded(this.props.viewer)}
																			dragActive={this.state.dragActive}
																			projectPersons={projectPersons}
																			showEmptyPersons={this.state.showEmptyPersons}
																			groupByPerson={this.state.groupByPerson}
																			groupByRole={this.state.groupByRole}
																			tableMinWidth={totalTableMinWidth}
																			cy={'milestone'}
																			collapsed={isCollapsed}
																			forceHidden={!isCollapsed && !isVisible && this.draggedOrigin !== phase.id}
																			phaseHeader={phaseHeader}
																			selectionMode={this.state.selectionMode}
																			containerWidth={this.state.containerWidth}
																			showTaskModal={taskId => Util.showTaskModal(taskId, this.props.history)}
																			projectLocked={projectLocked}
																			isJiraProject={this.props.viewer.project.isJiraProject}
																			phaseIndex={index}
																			phase={phase}
																			sortedSprints={sortedSprints}
																			project={project}
																			projectId={project.id}
																			emptyPhase={false}
																			focusAddControls={this.state.focusPhaseId === phase.id}
																			roles={roles}
																			isEstimatedInHours={isEstimatedInHours}
																			locale={locale}
																			hasRateCard={hasRateCard}
																			currencySymbol={currencySymbol}
																			placeUnitBeforeValue={placeUnitBeforeValue}
																			hasFinancialAccess={hasFinancialAccess}
																			language={this.props.viewer.language}
																			//calculateTablesSize={this.calculateTablesSize.bind(this)}
																			//showPrice={this.state.showPrice}
																			//showCurrentPrice={this.state.showCurrentPrice}
																			//function never used
																			//handlePromptEvent={this.props.route.handlePromptEvent}
																			projectTasks={this.props.viewer.project.tasks.edges}
																			viewer={this.props.viewer}
																			availableColumns={this.state.availableColumns}
																			columnWidths={this.state.columnWidths}
																			dragAndDropGroup={this.state.dragAndDropGroup}
																			handleRowSelected={this.registerRowSelection}
																			onSelectAllTasks={this.handleSelectMultipleTasks}
																			onDeselectAllTasks={this.handleDeselectMultipleTasks}
																			selectedRows={this.state.selectedTasks}
																			taskCellMaxWidth={this.state.taskCellMaxWidth}
																			filters={this.state.filters}
																			minutesPerEstimationPoint={this.props.viewer.project.minutesPerEstimationPoint}
																			//showTaskLocationModal={this.props.route.showTaskLocationModal}
																			unselectTasks={this.unselectTasks.bind(this)}
																			fixedPriceDataProjectMap={fixedPriceDataProjectMap}
																			fixedPriceUtil={this.fixedPriceUtil}
																		/>
																	);
																}}
															</VisibilitySensor>
														)}
													</div>
												);
											})}
										</>
									);
								} else {
									return null;
								}
							})}
							<PhasesPeriodHeader period={null} intl={this.props.intl} minWidth={totalTableMinWidth} />
							{phasesOutsidePeriods.length > 0
								? phasesOutsidePeriods.map((phase, index) => {
										const phaseHeader = (
											<PhasesPhaseHeader
												lazyDataFetched={this.state.lazyDataFetched}
												cy={'milestone-header'}
												disabled={projectLocked || !updateMilestoneAccess}
												phaseIndex={index}
												phase={phase}
												project={project}
												company={this.props.viewer.company}
												emptyPhase={false}
												isEstimatedInHours={isEstimatedInHours}
												hasRateCard={hasRateCard}
												currencySymbol={currencySymbol}
												placeUnitBeforeValue={placeUnitBeforeValue}
												hasFinancialAccess={hasFinancialAccess}
												availableColumns={this.state.availableColumns}
												onExpansionChange={this.togglePhaseExpanded.bind(this)}
												expanded={this.getIsPhaseExpanded(phase.id)}
												isNewMilestone={this.state.focusPhaseId === phase.id}
												scrollToNewMilestone={this.scrollToNewMilestone}
												retry={this.refetch}
												// showMilestoneLocationModal={this.props.route.showMilestoneLocationModal}
												viewer={this.props.viewer}
												taskCellMaxWidth={this.state.taskCellMaxWidth}
												moveMilestoneDisabled={!!moveMilestoneDisabled}
												isBaselineProject={isBaselineProject}
											/>
										);
										//let minWidth = this.state.availableColumns.find(elem => elem.name === 'approved').checked ? this.state.tableMinWidth : this.state.tableMinWidth + 92;
										return (
											<div
												key={phase.id}
												id={'phase-wrapper-' + phase.id}
												data-cy="new-ui-scoping-phase-wrapper"
												className={'phase-wrapper' + (phase.hide || (phase.tasks.length === 0 && activeFiltersCount > 0) ? ' no-margin' : '')}
												style={{
													minWidth: totalTableMinWidth,
												}}
											>
												{phase.hide || (phase.tasks.length === 0 && activeFiltersCount > 0) ? null : (
													<VisibilitySensor scrollCheck={true} partialVisibility offset={{top: -100, bottom: -300}}>
														{({isVisible}) => {
															const isCollapsed = !this.getIsPhaseExpanded(phase.id);
															return (
																<PhasesPhase
																	timeRegistrationsLoaded={this.isTaskTimeRegistrationsLoaded(this.props.viewer)}
																	dragActive={this.state.dragActive}
																	projectPersons={projectPersons}
																	showEmptyPersons={this.state.showEmptyPersons}
																	groupByPerson={this.state.groupByPerson}
																	groupByRole={this.state.groupByRole}
																	tableMinWidth={totalTableMinWidth}
																	cy={'milestone'}
																	collapsed={isCollapsed}
																	forceHidden={!isCollapsed && !isVisible && this.draggedOrigin !== phase.id}
																	phaseHeader={phaseHeader}
																	selectionMode={this.state.selectionMode}
																	containerWidth={this.state.containerWidth}
																	showTaskModal={taskId => Util.showTaskModal(taskId, this.props.history)}
																	projectLocked={projectLocked}
																	isJiraProject={this.props.viewer.project.isJiraProject}
																	phaseIndex={index}
																	phase={phase}
																	sortedSprints={sortedSprints}
																	project={project}
																	projectId={project.id}
																	emptyPhase={false}
																	focusAddControls={this.state.focusPhaseId === phase.id}
																	roles={roles}
																	isEstimatedInHours={isEstimatedInHours}
																	locale={locale}
																	hasRateCard={hasRateCard}
																	currencySymbol={currencySymbol}
																	placeUnitBeforeValue={placeUnitBeforeValue}
																	hasFinancialAccess={hasFinancialAccess}
																	language={this.props.viewer.language}
																	//calculateTablesSize={this.calculateTablesSize.bind(this)}
																	//showPrice={this.state.showPrice}
																	//showCurrentPrice={this.state.showCurrentPrice}
																	//function never used
																	//handlePromptEvent={this.props.route.handlePromptEvent}
																	projectTasks={this.props.viewer.project.tasks.edges}
																	viewer={this.props.viewer}
																	availableColumns={this.state.availableColumns}
																	columnWidths={this.state.columnWidths}
																	dragAndDropGroup={this.state.dragAndDropGroup}
																	handleRowSelected={this.registerRowSelection}
																	onSelectAllTasks={this.handleSelectMultipleTasks}
																	onDeselectAllTasks={this.handleDeselectMultipleTasks}
																	selectedRows={this.state.selectedTasks}
																	taskCellMaxWidth={this.state.taskCellMaxWidth}
																	filters={this.state.filters}
																	minutesPerEstimationPoint={this.props.viewer.project.minutesPerEstimationPoint}
																	//showTaskLocationModal={this.props.route.showTaskLocationModal}
																	unselectTasks={this.unselectTasks.bind(this)}
																	fixedPriceDataProjectMap={fixedPriceDataProjectMap}
																	fixedPriceUtil={this.fixedPriceUtil}
																/>
															);
														}}
													</VisibilitySensor>
												)}
											</div>
										);
								  })
								: null}
							{empty_phase.tasks.length !== 0 ? (
								<div className="phase-wrapper empty" style={{minWidth: totalTableMinWidth}}>
									<PhasesPhase
										timeRegistrationsLoaded={this.isTaskTimeRegistrationsLoaded(this.props.viewer)}
										dragActive={this.state.dragActive}
										emptyPhase={true}
										projectPersons={projectPersons}
										showEmptyPersons={this.state.showEmptyPersons}
										groupByPerson={this.state.groupByPerson}
										groupByRole={this.state.groupByRole}
										tableMinWidth={totalTableMinWidth}
										cy={''}
										phaseHeader={emptyPhaseHeader}
										selectionMode={this.state.selectionMode}
										containerWidth={this.state.containerWidth}
										dragAndDropGroup={this.state.dragAndDropGroup}
										showTaskModal={taskId => Util.showTaskModal(taskId, this.props.history)}
										projectLocked={projectLocked}
										isJiraProject={this.props.viewer.project.isJiraProject}
										phase={empty_phase}
										sortedSprints={sortedSprints}
										project={project}
										projectId={project.id}
										roles={roles}
										isEstimatedInHours={isEstimatedInHours}
										hasRateCard={hasRateCard}
										currencySymbol={currencySymbol}
										placeUnitBeforeValue={placeUnitBeforeValue}
										hasFinancialAccess={hasFinancialAccess}
										language={this.props.viewer.language}
										//calculateTablesSize={this.calculateTablesSize.bind(this)}
										showPrice={this.state.showPrice}
										showCurrentPrice={this.state.showCurrentPrice}
										projectTasks={this.props.viewer.project.tasks.edges}
										viewer={this.props.viewer}
										availableColumns={this.state.availableColumns}
										columnWidths={this.state.columnWidths}
										handleRowSelected={this.registerRowSelection}
										onSelectAllTasks={this.handleSelectMultipleTasks}
										onDeselectAllTasks={this.handleDeselectMultipleTasks}
										selectedRows={this.state.selectedTasks}
										taskCellMaxWidth={this.state.taskCellMaxWidth}
										minutesPerEstimationPoint={this.props.viewer.project.minutesPerEstimationPoint}
										//showTaskLocationModal={this.props.route.showTaskLocationModal}
										unselectTasks={this.unselectTasks.bind(this)}
										fixedPriceDataProjectMap={fixedPriceDataProjectMap}
										fixedPriceUtil={this.fixedPriceUtil}
									/>
								</div>
							) : null}
						</DragDropContext>
					</div>
				) : (
					/* Retainer Project Scoping end */
					<div ref={div => (this.section_body = div)} className={'section-body flow-sample-scoping-milestone'}>
						<DragDropContext
							ref={div => (this.dnd_context = div)}
							scrollYSpeed={25}
							scrollContainerHeight={this.state.contextHeight || window.innerHeight}
							scrollContainerMinHeight={this.state.contextHeight || window.innerHeight}
							dragAndDropGroup={this.state.dragAndDropGroup}
							onDragEnd={this.handleTaskDrag.bind(this)}
							onDragStart={this.handleDragStart.bind(this)}
							outerScrollBar={true}
						>
							<ProjectTotalHeader
								lazyDataFetched={this.state.lazyDataFetched}
								done={done}
								low={low}
								high={high}
								forecast={forecast}
								remaining={remaining}
								price={price}
								actualPrice={actualPrice}
								timeEntries={timeEntries}
								overHigh={overHigh}
								hasScroll={this.state.hasScroll}
								overForecast={overForecast}
								tableMinWidth={totalTableMinWidth}
								hasApproved={this.state.availableColumns.some(col => col.name === 'approved' && col.checked)}
								projectTotalExpanded={this.state.projectTotalExpanded}
								toggleProjectTotalExpanded={this.toggleProjectTotalExpanded.bind(this)}
								availableColumns={this.state.availableColumns}
								taskCellMaxWidth={this.state.taskCellMaxWidth}
								projectTimeRegistered={projectTimeRegistered}
								projectReportedTimePrice={projectReportedTimePrice}
								baselineHeaderElement={
									this.state.showBaselineInfo ? (
										<div style={{margin: '17px 0px 26px 0px'}}>
											<PhasesBaselineHeader
												targetPrice={this.props.viewer.project.baselineTargetPriceNoExpenses}
												targetMinutes={this.props.viewer.project.baselineTargetMinutes}
												currencySymbol={currencySymbol}
												availableColumns={this.state.availableColumns}
												taskCellMaxWidth={this.state.taskCellMaxWidth}
												intl={this.props.intl}
											/>
										</div>
									) : null
								}
							/>

							{phases.map((phase, index) => {
								const phaseHeader = (
									<>
										<PhasesPhaseHeader
											lazyDataFetched={this.state.lazyDataFetched}
											cy={'milestone-header'}
											disabled={projectLocked || !updateMilestoneAccess}
											phaseIndex={index}
											phase={phase}
											project={project}
											company={this.props.viewer.company}
											emptyPhase={false}
											isEstimatedInHours={isEstimatedInHours}
											hasRateCard={hasRateCard}
											currencySymbol={currencySymbol}
											placeUnitBeforeValue={placeUnitBeforeValue}
											hasFinancialAccess={hasFinancialAccess}
											availableColumns={this.state.availableColumns}
											onExpansionChange={this.togglePhaseExpanded.bind(this)}
											expanded={this.getIsPhaseExpanded(phase.id)}
											isNewMilestone={this.state.focusPhaseId === phase.id}
											scrollToNewMilestone={this.scrollToNewMilestone}
											retry={this.refetch}
											// showMilestoneLocationModal={this.props.route.showMilestoneLocationModal}
											viewer={this.props.viewer}
											taskCellMaxWidth={this.state.taskCellMaxWidth}
											moveMilestoneDisabled={!!moveMilestoneDisabled}
											isBaselineProject={isBaselineProject}
										/>
										{this.state.showBaselineInfo ? (
											<PhasesBaselineHeader
												targetPrice={phase.baselineTargetPriceNoExpenses}
												targetMinutes={phase.baselineTargetMinutes}
												currencySymbol={currencySymbol}
												availableColumns={this.state.availableColumns}
												taskCellMaxWidth={this.state.taskCellMaxWidth}
												intl={this.props.intl}
											/>
										) : null}
									</>
								);
								//let minWidth = this.state.availableColumns.find(elem => elem.name === 'approved').checked ? this.state.tableMinWidth : this.state.tableMinWidth + 92;
								return (
									<div
										key={phase.id}
										id={'phase-wrapper-' + phase.id}
										data-cy="new-ui-scoping-phase-wrapper"
										className={'phase-wrapper' + (phase.hide || (phase.tasks.length === 0 && activeFiltersCount > 0) ? ' no-margin' : '')}
										style={{
											minWidth: totalTableMinWidth,
										}}
									>
										{phase.hide || (phase.tasks.length === 0 && activeFiltersCount > 0) ? null : (
											<VisibilitySensor scrollCheck={true} partialVisibility offset={{top: -100, bottom: -300}}>
												{({isVisible}) => {
													const isCollapsed = !this.getIsPhaseExpanded(phase.id);
													return (
														<PhasesPhase
															timeRegistrationsLoaded={this.isTaskTimeRegistrationsLoaded(this.props.viewer)}
															showPhaseBaselineHeader={this.state.showBaselineInfo}
															dragActive={this.state.dragActive}
															projectPersons={projectPersons}
															showEmptyPersons={this.state.showEmptyPersons}
															groupByPerson={this.state.groupByPerson}
															groupByRole={this.state.groupByRole}
															tableMinWidth={totalTableMinWidth}
															cy={'milestone'}
															collapsed={isCollapsed}
															forceHidden={!isCollapsed && !isVisible && this.draggedOrigin !== phase.id}
															phaseHeader={phaseHeader}
															selectionMode={this.state.selectionMode}
															containerWidth={this.state.containerWidth}
															showTaskModal={taskId => Util.showTaskModal(taskId, this.props.history)}
															projectLocked={projectLocked}
															isJiraProject={this.props.viewer.project.isJiraProject}
															phaseIndex={index}
															phase={phase}
															sortedSprints={sortedSprints}
															project={project}
															projectId={project.id}
															emptyPhase={false}
															focusAddControls={this.state.focusPhaseId === phase.id}
															roles={roles}
															isEstimatedInHours={isEstimatedInHours}
															locale={locale}
															hasRateCard={hasRateCard}
															currencySymbol={currencySymbol}
															placeUnitBeforeValue={placeUnitBeforeValue}
															hasFinancialAccess={hasFinancialAccess}
															language={this.props.viewer.language}
															//calculateTablesSize={this.calculateTablesSize.bind(this)}
															//showPrice={this.state.showPrice}
															//showCurrentPrice={this.state.showCurrentPrice}
															//function never used
															//handlePromptEvent={this.props.route.handlePromptEvent}
															projectTasks={this.props.viewer.project.tasks.edges}
															viewer={this.props.viewer}
															availableColumns={this.state.availableColumns}
															columnWidths={this.state.columnWidths}
															dragAndDropGroup={this.state.dragAndDropGroup}
															handleRowSelected={this.registerRowSelection}
															onSelectAllTasks={this.handleSelectMultipleTasks}
															onDeselectAllTasks={this.handleDeselectMultipleTasks}
															selectedRows={this.state.selectedTasks}
															taskCellMaxWidth={this.state.taskCellMaxWidth}
															filters={this.state.filters}
															minutesPerEstimationPoint={this.props.viewer.project.minutesPerEstimationPoint}
															//showTaskLocationModal={this.props.route.showTaskLocationModal}
															unselectTasks={this.unselectTasks.bind(this)}
															fixedPriceDataProjectMap={fixedPriceDataProjectMap}
															fixedPriceUtil={this.fixedPriceUtil}
														/>
													);
												}}
											</VisibilitySensor>
										)}
									</div>
								);
							})}
							{empty_phase.tasks.length !== 0 ? (
								<div className="phase-wrapper empty" style={{minWidth: totalTableMinWidth}}>
									<PhasesPhase
										timeRegistrationsLoaded={this.isTaskTimeRegistrationsLoaded(this.props.viewer)}
										dragActive={this.state.dragActive}
										emptyPhase={true}
										projectPersons={projectPersons}
										showEmptyPersons={this.state.showEmptyPersons}
										groupByPerson={false}
										groupByRole={this.state.groupByRole}
										tableMinWidth={totalTableMinWidth}
										cy={''}
										phaseHeader={emptyPhaseHeader}
										selectionMode={this.state.selectionMode}
										containerWidth={this.state.containerWidth}
										dragAndDropGroup={this.state.dragAndDropGroup}
										showTaskModal={taskId => Util.showTaskModal(taskId, this.props.history)}
										projectLocked={projectLocked}
										isJiraProject={this.props.viewer.project.isJiraProject}
										phase={empty_phase}
										sortedSprints={sortedSprints}
										project={project}
										projectId={project.id}
										roles={roles}
										isEstimatedInHours={isEstimatedInHours}
										hasRateCard={hasRateCard}
										currencySymbol={currencySymbol}
										placeUnitBeforeValue={placeUnitBeforeValue}
										hasFinancialAccess={hasFinancialAccess}
										language={this.props.viewer.language}
										//calculateTablesSize={this.calculateTablesSize.bind(this)}
										showPrice={this.state.showPrice}
										showCurrentPrice={this.state.showCurrentPrice}
										projectTasks={this.props.viewer.project.tasks.edges}
										viewer={this.props.viewer}
										availableColumns={this.state.availableColumns}
										columnWidths={this.state.columnWidths}
										handleRowSelected={this.registerRowSelection}
										onSelectAllTasks={this.handleSelectMultipleTasks}
										onDeselectAllTasks={this.handleDeselectMultipleTasks}
										selectedRows={this.state.selectedTasks}
										taskCellMaxWidth={this.state.taskCellMaxWidth}
										minutesPerEstimationPoint={this.props.viewer.project.minutesPerEstimationPoint}
										//showTaskLocationModal={this.props.route.showTaskLocationModal}
										unselectTasks={this.unselectTasks.bind(this)}
										fixedPriceDataProjectMap={fixedPriceDataProjectMap}
										fixedPriceUtil={this.fixedPriceUtil}
									/>
								</div>
							) : null}
						</DragDropContext>
					</div>
				)}
			</div>
		);
	}
}

export default injectIntl(withRouter(ProjectPhases));
